import { emptySurveyApi as api } from './api';
export const addTagTypes = [
  'AggregationTypes',
  'AIGenerationJob',
  'BackgroundJobLogs',
  'Blocks',
  'BlockTypeOptions',
  'Blueprints',
  'CustomTopics',
  'DisqualificationLogics',
  'ExternalSurveys',
  'HighlighterProfileSurveys',
  'LineItems',
  'ResultContexts',
  'MaterializedSurveys',
  'MaxPositions',
  'PhotoQcReview',
  'QualityControl',
  'QuestionChoices',
  'QuestionDesignChoices',
  'QuestionDesigns',
  'Questions',
  'ScoreCardEntries',
  'Segments',
  'ShowLogics',
  'Slots',
  'SurveyConfigBlockGroups',
  'SurveyConfigBlocks',
  'SurveyConfigs',
  'SurveyIngestors',
  'SurveyResponses',
  'SurveyResults',
  'SurveyReview',
  'TextProcessing',
  'VariableLogics',
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getAggregationtypes: build.query<GetAggregationtypesApiResponse, GetAggregationtypesApiArg>({
        query: () => ({ url: `/aggregationtypes` }),
        providesTags: ['AggregationTypes'],
      }),
      getAiGenerationJobByJobIdStatus: build.query<
        GetAiGenerationJobByJobIdStatusApiResponse,
        GetAiGenerationJobByJobIdStatusApiArg
      >({
        query: (queryArg) => ({ url: `/AIGenerationJob/${queryArg.jobId}/status` }),
        providesTags: ['AIGenerationJob'],
      }),
      getBackgroundjoblogs: build.query<
        GetBackgroundjoblogsApiResponse,
        GetBackgroundjoblogsApiArg
      >({
        query: () => ({ url: `/backgroundjoblogs` }),
        providesTags: ['BackgroundJobLogs'],
      }),
      getBlocks: build.query<GetBlocksApiResponse, GetBlocksApiArg>({
        query: () => ({ url: `/Blocks` }),
        providesTags: ['Blocks'],
      }),
      postBlocks: build.mutation<PostBlocksApiResponse, PostBlocksApiArg>({
        query: (queryArg) => ({ url: `/Blocks`, method: 'POST', body: queryArg.block }),
        invalidatesTags: ['Blocks'],
      }),
      postBlocksBulkGet: build.mutation<PostBlocksBulkGetApiResponse, PostBlocksBulkGetApiArg>({
        query: (queryArg) => ({
          url: `/Blocks/$bulkGet`,
          method: 'POST',
          body: queryArg.bulkGetRequest,
        }),
        invalidatesTags: ['Blocks'],
      }),
      putBlocksByBlockId: build.mutation<PutBlocksByBlockIdApiResponse, PutBlocksByBlockIdApiArg>({
        query: (queryArg) => ({
          url: `/Blocks/${queryArg.blockId}`,
          method: 'PUT',
          body: queryArg.block,
        }),
        invalidatesTags: ['Blocks'],
      }),
      deleteBlocksByBlockId: build.mutation<
        DeleteBlocksByBlockIdApiResponse,
        DeleteBlocksByBlockIdApiArg
      >({
        query: (queryArg) => ({ url: `/Blocks/${queryArg.blockId}`, method: 'DELETE' }),
        invalidatesTags: ['Blocks'],
      }),
      getBlocksQuestionDesignByQuestionDesignId: build.query<
        GetBlocksQuestionDesignByQuestionDesignIdApiResponse,
        GetBlocksQuestionDesignByQuestionDesignIdApiArg
      >({
        query: (queryArg) => ({ url: `/Blocks/QuestionDesign/${queryArg.questionDesignId}` }),
        providesTags: ['Blocks'],
      }),
      getBlockTypeOptions: build.query<GetBlockTypeOptionsApiResponse, GetBlockTypeOptionsApiArg>({
        query: () => ({ url: `/BlockTypeOptions` }),
        providesTags: ['BlockTypeOptions'],
      }),
      postBlueprints: build.mutation<PostBlueprintsApiResponse, PostBlueprintsApiArg>({
        query: (queryArg) => ({
          url: `/Blueprints`,
          method: 'POST',
          body: queryArg.bulkCreateRequest,
        }),
        invalidatesTags: ['Blueprints'],
      }),
      postBlueprintsBulkCreate: build.mutation<
        PostBlueprintsBulkCreateApiResponse,
        PostBlueprintsBulkCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/Blueprints/$bulkCreate`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Blueprints'],
      }),
      postLineItemsByLineItemIdCustomTopics: build.mutation<
        PostLineItemsByLineItemIdCustomTopicsApiResponse,
        PostLineItemsByLineItemIdCustomTopicsApiArg
      >({
        query: (queryArg) => ({
          url: `/LineItems/${queryArg.lineItemId}/CustomTopics`,
          method: 'POST',
          body: queryArg.createCustomTopicRequest,
        }),
        invalidatesTags: ['CustomTopics'],
      }),
      getSurveyconfigsBySurveyConfigIdDisqualificationlogics: build.query<
        GetSurveyconfigsBySurveyConfigIdDisqualificationlogicsApiResponse,
        GetSurveyconfigsBySurveyConfigIdDisqualificationlogicsApiArg
      >({
        query: (queryArg) => ({
          url: `/surveyconfigs/${queryArg.surveyConfigId}/disqualificationlogics`,
        }),
        providesTags: ['DisqualificationLogics'],
      }),
      putSurveyconfigsBySurveyConfigIdDisqualificationlogicsAndId: build.mutation<
        PutSurveyconfigsBySurveyConfigIdDisqualificationlogicsAndIdApiResponse,
        PutSurveyconfigsBySurveyConfigIdDisqualificationlogicsAndIdApiArg
      >({
        query: (queryArg) => ({
          url: `/surveyconfigs/${queryArg.surveyConfigId}/disqualificationlogics/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.disqualificationLogic,
        }),
        invalidatesTags: ['DisqualificationLogics'],
      }),
      deleteSurveyconfigsBySurveyConfigIdDisqualificationlogicsAndId: build.mutation<
        DeleteSurveyconfigsBySurveyConfigIdDisqualificationlogicsAndIdApiResponse,
        DeleteSurveyconfigsBySurveyConfigIdDisqualificationlogicsAndIdApiArg
      >({
        query: (queryArg) => ({
          url: `/surveyconfigs/${queryArg.surveyConfigId}/disqualificationlogics/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['DisqualificationLogics'],
      }),
      getSurveyconfigsBySurveyConfigIdDisqualificationlogicsValidation: build.query<
        GetSurveyconfigsBySurveyConfigIdDisqualificationlogicsValidationApiResponse,
        GetSurveyconfigsBySurveyConfigIdDisqualificationlogicsValidationApiArg
      >({
        query: (queryArg) => ({
          url: `/surveyconfigs/${queryArg.surveyConfigId}/disqualificationlogics/$validation`,
        }),
        providesTags: ['DisqualificationLogics'],
      }),
      getExternalSurveys: build.query<GetExternalSurveysApiResponse, GetExternalSurveysApiArg>({
        query: () => ({ url: `/ExternalSurveys` }),
        providesTags: ['ExternalSurveys'],
      }),
      postHighlighterProfileSurveys: build.mutation<
        PostHighlighterProfileSurveysApiResponse,
        PostHighlighterProfileSurveysApiArg
      >({
        query: (queryArg) => ({
          url: `/HighlighterProfileSurveys`,
          method: 'POST',
          body: queryArg.highlighterProfileSurvey,
        }),
        invalidatesTags: ['HighlighterProfileSurveys'],
      }),
      patchHighlighterProfileSurveys: build.mutation<
        PatchHighlighterProfileSurveysApiResponse,
        PatchHighlighterProfileSurveysApiArg
      >({
        query: (queryArg) => ({
          url: `/HighlighterProfileSurveys`,
          method: 'PATCH',
          body: queryArg.highlighterProfileSurvey,
        }),
        invalidatesTags: ['HighlighterProfileSurveys'],
      }),
      getHighlighterProfileSurveys: build.query<
        GetHighlighterProfileSurveysApiResponse,
        GetHighlighterProfileSurveysApiArg
      >({
        query: (queryArg) => ({
          url: `/HighlighterProfileSurveys`,
          params: {
            externalId: queryArg.externalId,
            vendorName: queryArg.vendorName,
            communitySlug: queryArg.communitySlug,
          },
        }),
        providesTags: ['HighlighterProfileSurveys'],
      }),
      postHighlighterProfileSurveysFinalizeQuestions: build.mutation<
        PostHighlighterProfileSurveysFinalizeQuestionsApiResponse,
        PostHighlighterProfileSurveysFinalizeQuestionsApiArg
      >({
        query: (queryArg) => ({
          url: `/HighlighterProfileSurveys/$finalizeQuestions`,
          method: 'POST',
          body: queryArg.finalizeQuestionRequest,
        }),
        invalidatesTags: ['HighlighterProfileSurveys'],
      }),
      getHighlighterProfileSurveysById: build.query<
        GetHighlighterProfileSurveysByIdApiResponse,
        GetHighlighterProfileSurveysByIdApiArg
      >({
        query: (queryArg) => ({ url: `/HighlighterProfileSurveys/${queryArg.id}` }),
        providesTags: ['HighlighterProfileSurveys'],
      }),
      postLineItems: build.mutation<PostLineItemsApiResponse, PostLineItemsApiArg>({
        query: (queryArg) => ({ url: `/LineItems`, method: 'POST', body: queryArg.lineItem }),
        invalidatesTags: ['LineItems'],
      }),
      putLineItems: build.mutation<PutLineItemsApiResponse, PutLineItemsApiArg>({
        query: (queryArg) => ({ url: `/LineItems`, method: 'PUT', body: queryArg.lineItem }),
        invalidatesTags: ['LineItems'],
      }),
      deleteLineItemsByLineItemId: build.mutation<
        DeleteLineItemsByLineItemIdApiResponse,
        DeleteLineItemsByLineItemIdApiArg
      >({
        query: (queryArg) => ({ url: `/LineItems/${queryArg.lineItemId}`, method: 'DELETE' }),
        invalidatesTags: ['LineItems'],
      }),
      postLineItemsByLineItemIdSetordinal: build.mutation<
        PostLineItemsByLineItemIdSetordinalApiResponse,
        PostLineItemsByLineItemIdSetordinalApiArg
      >({
        query: (queryArg) => ({
          url: `/LineItems/${queryArg.lineItemId}/$setordinal`,
          method: 'POST',
          body: queryArg.setOrdinalRequest,
        }),
        invalidatesTags: ['LineItems'],
      }),
      postLineItemsBatch: build.mutation<PostLineItemsBatchApiResponse, PostLineItemsBatchApiArg>({
        query: (queryArg) => ({
          url: `/LineItems/batch`,
          method: 'POST',
          body: queryArg.lineItemBatchRequest,
        }),
        invalidatesTags: ['LineItems'],
      }),
      getResultContextsByResultContextIdLineitems: build.query<
        GetResultContextsByResultContextIdLineitemsApiResponse,
        GetResultContextsByResultContextIdLineitemsApiArg
      >({
        query: (queryArg) => ({
          url: `/ResultContexts/${queryArg.resultContextId}/lineitems`,
          params: {
            scope: queryArg.scope,
          },
        }),
        providesTags: ['LineItems'],
      }),
      postResultContextsByResultContextIdLineitems: build.mutation<
        PostResultContextsByResultContextIdLineitemsApiResponse,
        PostResultContextsByResultContextIdLineitemsApiArg
      >({
        query: (queryArg) => ({
          url: `/ResultContexts/${queryArg.resultContextId}/lineitems`,
          method: 'POST',
          body: queryArg.resultContextPopulateRequest,
        }),
        invalidatesTags: ['ResultContexts'],
      }),
      getResultContextsByResultContextIdQuestioninventory: build.query<
        GetResultContextsByResultContextIdQuestioninventoryApiResponse,
        GetResultContextsByResultContextIdQuestioninventoryApiArg
      >({
        query: (queryArg) => ({
          url: `/ResultContexts/${queryArg.resultContextId}/questioninventory`,
        }),
        providesTags: ['LineItems'],
      }),
      getResultContextsByResultContextIdLineitemsHasany: build.query<
        GetResultContextsByResultContextIdLineitemsHasanyApiResponse,
        GetResultContextsByResultContextIdLineitemsHasanyApiArg
      >({
        query: (queryArg) => ({
          url: `/ResultContexts/${queryArg.resultContextId}/lineitems/hasany`,
          params: {
            scope: queryArg.scope,
          },
        }),
        providesTags: ['LineItems'],
      }),
      getMaterializedSurveysByMaterializedSurveyId: build.query<
        GetMaterializedSurveysByMaterializedSurveyIdApiResponse,
        GetMaterializedSurveysByMaterializedSurveyIdApiArg
      >({
        query: (queryArg) => ({ url: `/MaterializedSurveys/${queryArg.materializedSurveyId}` }),
        providesTags: ['MaterializedSurveys'],
      }),
      putMaterializedSurveysByMaterializedSurveyId: build.mutation<
        PutMaterializedSurveysByMaterializedSurveyIdApiResponse,
        PutMaterializedSurveysByMaterializedSurveyIdApiArg
      >({
        query: (queryArg) => ({
          url: `/MaterializedSurveys/${queryArg.materializedSurveyId}`,
          method: 'PUT',
          body: queryArg.materializedSurveyDto,
        }),
        invalidatesTags: ['MaterializedSurveys'],
      }),
      getMaterializedSurveysByMaterializedSurveyIdQuestions: build.query<
        GetMaterializedSurveysByMaterializedSurveyIdQuestionsApiResponse,
        GetMaterializedSurveysByMaterializedSurveyIdQuestionsApiArg
      >({
        query: (queryArg) => ({
          url: `/MaterializedSurveys/${queryArg.materializedSurveyId}/questions`,
          params: {
            vendorName: queryArg.vendorName,
          },
        }),
        providesTags: ['MaterializedSurveys'],
      }),
      getMaterializedSurveysByMaterializedSurveyIdJson: build.query<
        GetMaterializedSurveysByMaterializedSurveyIdJsonApiResponse,
        GetMaterializedSurveysByMaterializedSurveyIdJsonApiArg
      >({
        query: (queryArg) => ({
          url: `/MaterializedSurveys/${queryArg.materializedSurveyId}/json`,
        }),
        providesTags: ['MaterializedSurveys'],
      }),
      getProjectsByProjectIdMaxPositions: build.query<
        GetProjectsByProjectIdMaxPositionsApiResponse,
        GetProjectsByProjectIdMaxPositionsApiArg
      >({
        query: (queryArg) => ({ url: `/Projects/${queryArg.projectId}/MaxPositions` }),
        providesTags: ['MaxPositions'],
      }),
      getPhotoqcreview: build.query<GetPhotoqcreviewApiResponse, GetPhotoqcreviewApiArg>({
        query: (queryArg) => ({
          url: `/photoqcreview`,
          params: {
            PageIndex: queryArg.pageIndex,
            PageSize: queryArg.pageSize,
            QualityRating: queryArg.qualityRating,
            From: queryArg['from'],
            To: queryArg.to,
          },
        }),
        providesTags: ['PhotoQcReview'],
      }),
      postQualitycontrolGetreport: build.mutation<
        PostQualitycontrolGetreportApiResponse,
        PostQualitycontrolGetreportApiArg
      >({
        query: (queryArg) => ({
          url: `/qualitycontrol/$getreport`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['QualityControl'],
      }),
      getQualitycontrolResponsedetailsBySurveyResponseId: build.query<
        GetQualitycontrolResponsedetailsBySurveyResponseIdApiResponse,
        GetQualitycontrolResponsedetailsBySurveyResponseIdApiArg
      >({
        query: (queryArg) => ({
          url: `/qualitycontrol/responsedetails/${queryArg.surveyResponseId}`,
        }),
        providesTags: ['QualityControl'],
      }),
      postQualitycontrolSubmitReview: build.mutation<
        PostQualitycontrolSubmitReviewApiResponse,
        PostQualitycontrolSubmitReviewApiArg
      >({
        query: (queryArg) => ({
          url: `/qualitycontrol/$submitReview`,
          method: 'POST',
          body: queryArg.submitReviewPayload,
        }),
        invalidatesTags: ['QualityControl'],
      }),
      postQualitycontrolSetAnswerExcluded: build.mutation<
        PostQualitycontrolSetAnswerExcludedApiResponse,
        PostQualitycontrolSetAnswerExcludedApiArg
      >({
        query: (queryArg) => ({
          url: `/qualitycontrol/$setAnswerExcluded`,
          method: 'POST',
          body: queryArg.setAnswerExcludedPayload,
        }),
        invalidatesTags: ['QualityControl'],
      }),
      getQuestionChoicesByChoiceId: build.query<
        GetQuestionChoicesByChoiceIdApiResponse,
        GetQuestionChoicesByChoiceIdApiArg
      >({
        query: (queryArg) => ({ url: `/QuestionChoices/${queryArg.choiceId}` }),
        providesTags: ['QuestionChoices'],
      }),
      patchQuestionChoicesByChoiceId: build.mutation<
        PatchQuestionChoicesByChoiceIdApiResponse,
        PatchQuestionChoicesByChoiceIdApiArg
      >({
        query: (queryArg) => ({
          url: `/QuestionChoices/${queryArg.choiceId}`,
          method: 'PATCH',
          body: queryArg.patchQuestionChoiceRequest,
        }),
        invalidatesTags: ['QuestionChoices'],
      }),
      postQuestionDesignsByQuestionDesignIdChoicesAssign: build.mutation<
        PostQuestionDesignsByQuestionDesignIdChoicesAssignApiResponse,
        PostQuestionDesignsByQuestionDesignIdChoicesAssignApiArg
      >({
        query: (queryArg) => ({
          url: `/QuestionDesigns/${queryArg.questionDesignId}/Choices/$assign`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['QuestionDesignChoices'],
      }),
      getQuestionDesignsByQuestionDesignIdChoices: build.query<
        GetQuestionDesignsByQuestionDesignIdChoicesApiResponse,
        GetQuestionDesignsByQuestionDesignIdChoicesApiArg
      >({
        query: (queryArg) => ({ url: `/QuestionDesigns/${queryArg.questionDesignId}/Choices` }),
        providesTags: ['QuestionDesignChoices'],
      }),
      getQuestionDesigns: build.query<GetQuestionDesignsApiResponse, GetQuestionDesignsApiArg>({
        query: () => ({ url: `/QuestionDesigns` }),
        providesTags: ['QuestionDesigns'],
      }),
      postQuestionDesigns: build.mutation<
        PostQuestionDesignsApiResponse,
        PostQuestionDesignsApiArg
      >({
        query: (queryArg) => ({
          url: `/QuestionDesigns`,
          method: 'POST',
          body: queryArg.questionDesign,
        }),
        invalidatesTags: ['QuestionDesigns'],
      }),
      putQuestionDesignsByQuestionDesignId: build.mutation<
        PutQuestionDesignsByQuestionDesignIdApiResponse,
        PutQuestionDesignsByQuestionDesignIdApiArg
      >({
        query: (queryArg) => ({
          url: `/QuestionDesigns/${queryArg.questionDesignId}`,
          method: 'PUT',
          body: queryArg.questionDesign,
        }),
        invalidatesTags: ['QuestionDesigns'],
      }),
      getQuestions: build.query<GetQuestionsApiResponse, GetQuestionsApiArg>({
        query: (queryArg) => ({
          url: `/Questions`,
          params: {
            surveyId: queryArg.surveyId,
            resultSchemaId: queryArg.resultSchemaId,
          },
        }),
        providesTags: ['Questions'],
      }),
      postQuestionsByQuestionIdConvert: build.mutation<
        PostQuestionsByQuestionIdConvertApiResponse,
        PostQuestionsByQuestionIdConvertApiArg
      >({
        query: (queryArg) => ({
          url: `/Questions/${queryArg.questionId}/$convert`,
          method: 'POST',
          body: queryArg.convertQuestionTypeRequest,
        }),
        invalidatesTags: ['Questions'],
      }),
      getQuestionsByQuestionId: build.query<
        GetQuestionsByQuestionIdApiResponse,
        GetQuestionsByQuestionIdApiArg
      >({
        query: (queryArg) => ({ url: `/Questions/${queryArg.questionId}` }),
        providesTags: ['Questions'],
      }),
      patchQuestionsByQuestionId: build.mutation<
        PatchQuestionsByQuestionIdApiResponse,
        PatchQuestionsByQuestionIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Questions/${queryArg.questionId}`,
          method: 'PATCH',
          body: queryArg.patchQuestionRequest,
        }),
        invalidatesTags: ['Questions'],
      }),
      getResultContexts: build.query<GetResultContextsApiResponse, GetResultContextsApiArg>({
        query: () => ({ url: `/ResultContexts` }),
        providesTags: ['ResultContexts'],
      }),
      postResultContexts: build.mutation<PostResultContextsApiResponse, PostResultContextsApiArg>({
        query: (queryArg) => ({
          url: `/ResultContexts`,
          method: 'POST',
          body: queryArg.resultContextDto,
        }),
        invalidatesTags: ['ResultContexts'],
      }),
      postResultContextsByResultContextIdDeletesummaries: build.mutation<
        PostResultContextsByResultContextIdDeletesummariesApiResponse,
        PostResultContextsByResultContextIdDeletesummariesApiArg
      >({
        query: (queryArg) => ({
          url: `/ResultContexts/${queryArg.resultContextId}/$deletesummaries`,
          method: 'POST',
        }),
        invalidatesTags: ['ResultContexts'],
      }),
      getResultContextsByResultContextIdSummarycount: build.query<
        GetResultContextsByResultContextIdSummarycountApiResponse,
        GetResultContextsByResultContextIdSummarycountApiArg
      >({
        query: (queryArg) => ({ url: `/ResultContexts/${queryArg.resultContextId}/summarycount` }),
        providesTags: ['ResultContexts'],
      }),
      postResultContextsByResultContextIdResetDashboard: build.mutation<
        PostResultContextsByResultContextIdResetDashboardApiResponse,
        PostResultContextsByResultContextIdResetDashboardApiArg
      >({
        query: (queryArg) => ({
          url: `/ResultContexts/${queryArg.resultContextId}/$resetDashboard`,
          method: 'POST',
        }),
        invalidatesTags: ['ResultContexts'],
      }),
      getResultContextsByResultContextIdScorecardentries: build.query<
        GetResultContextsByResultContextIdScorecardentriesApiResponse,
        GetResultContextsByResultContextIdScorecardentriesApiArg
      >({
        query: (queryArg) => ({
          url: `/ResultContexts/${queryArg.resultContextId}/scorecardentries`,
          params: {
            scope: queryArg.scope,
          },
        }),
        providesTags: ['ScoreCardEntries'],
      }),
      postScoreCardEntries: build.mutation<
        PostScoreCardEntriesApiResponse,
        PostScoreCardEntriesApiArg
      >({
        query: (queryArg) => ({
          url: `/ScoreCardEntries`,
          method: 'POST',
          body: queryArg.scoreCardEntry,
        }),
        invalidatesTags: ['ScoreCardEntries'],
      }),
      putScoreCardEntries: build.mutation<
        PutScoreCardEntriesApiResponse,
        PutScoreCardEntriesApiArg
      >({
        query: (queryArg) => ({
          url: `/ScoreCardEntries`,
          method: 'PUT',
          body: queryArg.scoreCardEntry,
        }),
        invalidatesTags: ['ScoreCardEntries'],
      }),
      postScoreCardEntriesBatch: build.mutation<
        PostScoreCardEntriesBatchApiResponse,
        PostScoreCardEntriesBatchApiArg
      >({
        query: (queryArg) => ({
          url: `/ScoreCardEntries/batch`,
          method: 'POST',
          body: queryArg.scoreCardEntryBatchRequest,
        }),
        invalidatesTags: ['ScoreCardEntries'],
      }),
      patchScoreCardEntriesUpdateOrdinals: build.mutation<
        PatchScoreCardEntriesUpdateOrdinalsApiResponse,
        PatchScoreCardEntriesUpdateOrdinalsApiArg
      >({
        query: (queryArg) => ({
          url: `/ScoreCardEntries/$updateOrdinals`,
          method: 'PATCH',
          body: queryArg.body,
        }),
        invalidatesTags: ['ScoreCardEntries'],
      }),
      deleteScoreCardEntriesByScorecardEntryId: build.mutation<
        DeleteScoreCardEntriesByScorecardEntryIdApiResponse,
        DeleteScoreCardEntriesByScorecardEntryIdApiArg
      >({
        query: (queryArg) => ({
          url: `/ScoreCardEntries/${queryArg.scorecardEntryId}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['ScoreCardEntries'],
      }),
      getSegmentsResultcontextsByResultContextIdEnabledSegments: build.query<
        GetSegmentsResultcontextsByResultContextIdEnabledSegmentsApiResponse,
        GetSegmentsResultcontextsByResultContextIdEnabledSegmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/segments/resultcontexts/${queryArg.resultContextId}/enabledSegments`,
        }),
        providesTags: ['Segments'],
      }),
      deleteSegmentsById: build.mutation<DeleteSegmentsByIdApiResponse, DeleteSegmentsByIdApiArg>({
        query: (queryArg) => ({ url: `/segments/${queryArg.id}`, method: 'DELETE' }),
        invalidatesTags: ['Segments'],
      }),
      postSegmentsResultcontextsByResultContextIdBackfillDefaultSegments: build.mutation<
        PostSegmentsResultcontextsByResultContextIdBackfillDefaultSegmentsApiResponse,
        PostSegmentsResultcontextsByResultContextIdBackfillDefaultSegmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/segments/resultcontexts/${queryArg.resultContextId}/$backfillDefaultSegments`,
          method: 'POST',
          body: queryArg.createDefaultSegmentsRequest,
          params: {
            _: queryArg._,
          },
        }),
        invalidatesTags: ['Segments'],
      }),
      getSurveyconfigsBySurveyConfigIdShowlogics: build.query<
        GetSurveyconfigsBySurveyConfigIdShowlogicsApiResponse,
        GetSurveyconfigsBySurveyConfigIdShowlogicsApiArg
      >({
        query: (queryArg) => ({ url: `/surveyconfigs/${queryArg.surveyConfigId}/showlogics` }),
        providesTags: ['ShowLogics'],
      }),
      getSurveyconfigsBySurveyConfigIdShowlogicsAndId: build.query<
        GetSurveyconfigsBySurveyConfigIdShowlogicsAndIdApiResponse,
        GetSurveyconfigsBySurveyConfigIdShowlogicsAndIdApiArg
      >({
        query: (queryArg) => ({
          url: `/surveyconfigs/${queryArg.surveyConfigId}/showlogics/${queryArg.id}`,
        }),
        providesTags: ['ShowLogics'],
      }),
      putSurveyconfigsBySurveyConfigIdShowlogicsAndId: build.mutation<
        PutSurveyconfigsBySurveyConfigIdShowlogicsAndIdApiResponse,
        PutSurveyconfigsBySurveyConfigIdShowlogicsAndIdApiArg
      >({
        query: (queryArg) => ({
          url: `/surveyconfigs/${queryArg.surveyConfigId}/showlogics/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.showLogic,
        }),
        invalidatesTags: ['ShowLogics'],
      }),
      deleteSurveyconfigsBySurveyConfigIdShowlogicsAndId: build.mutation<
        DeleteSurveyconfigsBySurveyConfigIdShowlogicsAndIdApiResponse,
        DeleteSurveyconfigsBySurveyConfigIdShowlogicsAndIdApiArg
      >({
        query: (queryArg) => ({
          url: `/surveyconfigs/${queryArg.surveyConfigId}/showlogics/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['ShowLogics'],
      }),
      getSurveyconfigsBySurveyConfigIdShowlogicsValidation: build.query<
        GetSurveyconfigsBySurveyConfigIdShowlogicsValidationApiResponse,
        GetSurveyconfigsBySurveyConfigIdShowlogicsValidationApiArg
      >({
        query: (queryArg) => ({
          url: `/surveyconfigs/${queryArg.surveyConfigId}/showlogics/$validation`,
        }),
        providesTags: ['ShowLogics'],
      }),
      getBlocksByBlockIdSlots: build.query<
        GetBlocksByBlockIdSlotsApiResponse,
        GetBlocksByBlockIdSlotsApiArg
      >({
        query: (queryArg) => ({ url: `/Blocks/${queryArg.blockId}/Slots` }),
        providesTags: ['Slots'],
      }),
      postBlocksByBlockIdSlotsAssign: build.mutation<
        PostBlocksByBlockIdSlotsAssignApiResponse,
        PostBlocksByBlockIdSlotsAssignApiArg
      >({
        query: (queryArg) => ({
          url: `/Blocks/${queryArg.blockId}/Slots/$assign`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Slots'],
      }),
      postSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsCreateMatrixGroup: build.mutation<
        PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsCreateMatrixGroupApiResponse,
        PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsCreateMatrixGroupApiArg
      >({
        query: (queryArg) => ({
          url: `/surveyConfigs/${queryArg.surveyConfigId}/surveyConfigBlockGroups/$createMatrixGroup`,
          method: 'POST',
          body: queryArg.matrixBlockRequest,
        }),
        invalidatesTags: ['SurveyConfigBlockGroups'],
      }),
      postSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdAddMatrixBlock:
        build.mutation<
          PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdAddMatrixBlockApiResponse,
          PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdAddMatrixBlockApiArg
        >({
          query: (queryArg) => ({
            url: `/surveyConfigs/${queryArg.surveyConfigId}/surveyConfigBlockGroups/${queryArg.surveyConfigBlockGroupId}/$addMatrixBlock`,
            method: 'POST',
            body: queryArg.addMatrixBlockRequest,
          }),
          invalidatesTags: ['SurveyConfigBlockGroups'],
        }),
      getSurveyConfigBlockGroups: build.query<
        GetSurveyConfigBlockGroupsApiResponse,
        GetSurveyConfigBlockGroupsApiArg
      >({
        query: (queryArg) => ({
          url: `/SurveyConfigBlockGroups`,
          params: {
            surveyConfigId: queryArg.surveyConfigId,
          },
        }),
        providesTags: ['SurveyConfigBlockGroups'],
      }),
      deleteSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupId:
        build.mutation<
          DeleteSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdApiResponse,
          DeleteSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdApiArg
        >({
          query: (queryArg) => ({
            url: `/surveyConfigs/${queryArg.surveyConfigId}/surveyConfigBlockGroups/${queryArg.surveyConfigBlockGroupId}`,
            method: 'DELETE',
          }),
          invalidatesTags: ['SurveyConfigBlockGroups'],
        }),
      patchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdName:
        build.mutation<
          PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdNameApiResponse,
          PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdNameApiArg
        >({
          query: (queryArg) => ({
            url: `/surveyConfigs/${queryArg.surveyConfigId}/surveyConfigBlockGroups/${queryArg.surveyConfigBlockGroupId}/name`,
            method: 'PATCH',
            body: queryArg.updateSurveyConfigBlockGroupNameRequest,
          }),
          invalidatesTags: ['SurveyConfigBlockGroups'],
        }),
      patchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdAreQuestionsRequired:
        build.mutation<
          PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdAreQuestionsRequiredApiResponse,
          PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdAreQuestionsRequiredApiArg
        >({
          query: (queryArg) => ({
            url: `/surveyConfigs/${queryArg.surveyConfigId}/surveyConfigBlockGroups/${queryArg.surveyConfigBlockGroupId}/areQuestionsRequired`,
            method: 'PATCH',
            body: queryArg.updateSurveyConfigBlockGroupAreQuestionsRequiredRequest,
          }),
          invalidatesTags: ['SurveyConfigBlockGroups'],
        }),
      patchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdBehaviors:
        build.mutation<
          PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdBehaviorsApiResponse,
          PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdBehaviorsApiArg
        >({
          query: (queryArg) => ({
            url: `/surveyConfigs/${queryArg.surveyConfigId}/surveyConfigBlockGroups/${queryArg.surveyConfigBlockGroupId}/behaviors`,
            method: 'PATCH',
            body: queryArg.body,
          }),
          invalidatesTags: ['SurveyConfigBlockGroups'],
        }),
      patchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdBlockIds:
        build.mutation<
          PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdBlockIdsApiResponse,
          PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdBlockIdsApiArg
        >({
          query: (queryArg) => ({
            url: `/surveyConfigs/${queryArg.surveyConfigId}/surveyConfigBlockGroups/${queryArg.surveyConfigBlockGroupId}/blockIds`,
            method: 'PATCH',
            body: queryArg.body,
          }),
          invalidatesTags: ['SurveyConfigBlockGroups'],
        }),
      postSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdPreview:
        build.mutation<
          PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdPreviewApiResponse,
          PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdPreviewApiArg
        >({
          query: (queryArg) => ({
            url: `/surveyConfigs/${queryArg.surveyConfigId}/surveyConfigBlockGroups/${queryArg.surveyConfigBlockGroupId}/$preview`,
            method: 'POST',
          }),
          invalidatesTags: ['SurveyConfigBlockGroups'],
        }),
      postSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdClone:
        build.mutation<
          PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdCloneApiResponse,
          PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdCloneApiArg
        >({
          query: (queryArg) => ({
            url: `/surveyConfigs/${queryArg.surveyConfigId}/surveyConfigBlockGroups/${queryArg.surveyConfigBlockGroupId}/$clone`,
            method: 'POST',
          }),
          invalidatesTags: ['SurveyConfigBlockGroups'],
        }),
      getSurveyConfigsBySurveyConfigIdBlocks: build.query<
        GetSurveyConfigsBySurveyConfigIdBlocksApiResponse,
        GetSurveyConfigsBySurveyConfigIdBlocksApiArg
      >({
        query: (queryArg) => ({ url: `/SurveyConfigs/${queryArg.surveyConfigId}/Blocks` }),
        providesTags: ['SurveyConfigBlocks'],
      }),
      postSurveyConfigsBySurveyConfigIdBlocksAndSurveyConfigBlockIdClone: build.mutation<
        PostSurveyConfigsBySurveyConfigIdBlocksAndSurveyConfigBlockIdCloneApiResponse,
        PostSurveyConfigsBySurveyConfigIdBlocksAndSurveyConfigBlockIdCloneApiArg
      >({
        query: (queryArg) => ({
          url: `/SurveyConfigs/${queryArg.surveyConfigId}/Blocks/${queryArg.surveyConfigBlockId}/$clone`,
          method: 'POST',
        }),
        invalidatesTags: ['SurveyConfigBlocks'],
      }),
      getSurveyConfigsBySurveyConfigIdQuestions: build.query<
        GetSurveyConfigsBySurveyConfigIdQuestionsApiResponse,
        GetSurveyConfigsBySurveyConfigIdQuestionsApiArg
      >({
        query: (queryArg) => ({ url: `/SurveyConfigs/${queryArg.surveyConfigId}/questions` }),
        providesTags: ['SurveyConfigs'],
      }),
      getSurveyConfigsBySurveyConfigIdResponseTagCounts: build.query<
        GetSurveyConfigsBySurveyConfigIdResponseTagCountsApiResponse,
        GetSurveyConfigsBySurveyConfigIdResponseTagCountsApiArg
      >({
        query: (queryArg) => ({
          url: `/SurveyConfigs/${queryArg.surveyConfigId}/responseTagCounts`,
        }),
        providesTags: ['SurveyConfigs'],
      }),
      getSurveyConfigs: build.query<GetSurveyConfigsApiResponse, GetSurveyConfigsApiArg>({
        query: () => ({ url: `/SurveyConfigs` }),
        providesTags: ['SurveyConfigs'],
      }),
      postSurveyConfigsConfigure: build.mutation<
        PostSurveyConfigsConfigureApiResponse,
        PostSurveyConfigsConfigureApiArg
      >({
        query: (queryArg) => ({
          url: `/SurveyConfigs/$configure`,
          method: 'POST',
          body: queryArg.configureSurveyRequest,
        }),
        invalidatesTags: ['SurveyConfigs'],
      }),
      postSurveyConfigsBySurveyConfigIdStartreporting: build.mutation<
        PostSurveyConfigsBySurveyConfigIdStartreportingApiResponse,
        PostSurveyConfigsBySurveyConfigIdStartreportingApiArg
      >({
        query: (queryArg) => ({
          url: `/SurveyConfigs/${queryArg.surveyConfigId}/$startreporting`,
          method: 'POST',
        }),
        invalidatesTags: ['SurveyConfigs'],
      }),
      getSurveyConfigsBySurveyConfigIdDefinition: build.query<
        GetSurveyConfigsBySurveyConfigIdDefinitionApiResponse,
        GetSurveyConfigsBySurveyConfigIdDefinitionApiArg
      >({
        query: (queryArg) => ({ url: `/SurveyConfigs/${queryArg.surveyConfigId}/$definition` }),
        providesTags: ['SurveyConfigs'],
      }),
      postSurveyConfigsBySurveyConfigIdExportDocx: build.mutation<
        PostSurveyConfigsBySurveyConfigIdExportDocxApiResponse,
        PostSurveyConfigsBySurveyConfigIdExportDocxApiArg
      >({
        query: (queryArg) => ({
          url: `/SurveyConfigs/${queryArg.surveyConfigId}/$exportDocx`,
          method: 'POST',
          params: {
            projectId: queryArg.projectId,
          },
        }),
        invalidatesTags: ['SurveyConfigs'],
      }),
      postSurveyConfigsBySurveyConfigIdResetresultschema: build.mutation<
        PostSurveyConfigsBySurveyConfigIdResetresultschemaApiResponse,
        PostSurveyConfigsBySurveyConfigIdResetresultschemaApiArg
      >({
        query: (queryArg) => ({
          url: `/SurveyConfigs/${queryArg.surveyConfigId}/$resetresultschema`,
          method: 'POST',
        }),
        invalidatesTags: ['SurveyConfigs'],
      }),
      postSurveyConfigsBySurveyConfigIdGenerateTestResponses: build.mutation<
        PostSurveyConfigsBySurveyConfigIdGenerateTestResponsesApiResponse,
        PostSurveyConfigsBySurveyConfigIdGenerateTestResponsesApiArg
      >({
        query: (queryArg) => ({
          url: `/SurveyConfigs/${queryArg.surveyConfigId}/generate-test-responses`,
          method: 'POST',
          body: queryArg.generateTestResponsesRequest,
        }),
        invalidatesTags: ['SurveyConfigs'],
      }),
      postSurveyingestorsByVendorNameResponses: build.mutation<
        PostSurveyingestorsByVendorNameResponsesApiResponse,
        PostSurveyingestorsByVendorNameResponsesApiArg
      >({
        query: (queryArg) => ({
          url: `/surveyingestors/${queryArg.vendorName}/responses`,
          method: 'POST',
          body: queryArg.vendorSurveyResponse,
        }),
        invalidatesTags: ['SurveyIngestors'],
      }),
      getSurveyresponses: build.query<GetSurveyresponsesApiResponse, GetSurveyresponsesApiArg>({
        query: (queryArg) => ({
          url: `/surveyresponses`,
          params: {
            surveyId: queryArg.surveyId,
            highlighterId: queryArg.highlighterId,
            surveyConfigId: queryArg.surveyConfigId,
          },
        }),
        providesTags: ['SurveyResponses'],
      }),
      deleteSurveyresponses: build.mutation<
        DeleteSurveyresponsesApiResponse,
        DeleteSurveyresponsesApiArg
      >({
        query: (queryArg) => ({
          url: `/surveyresponses`,
          method: 'DELETE',
          params: {
            resultSchemaId: queryArg.resultSchemaId,
            highlighterId: queryArg.highlighterId,
          },
        }),
        invalidatesTags: ['SurveyResponses'],
      }),
      getSurveyresponsesByIdSurveyConfig: build.query<
        GetSurveyresponsesByIdSurveyConfigApiResponse,
        GetSurveyresponsesByIdSurveyConfigApiArg
      >({
        query: (queryArg) => ({ url: `/surveyresponses/${queryArg.id}/surveyConfig` }),
        providesTags: ['SurveyResponses'],
      }),
      postSurveyresponsesByResultSchemaIdUploadTags: build.mutation<
        PostSurveyresponsesByResultSchemaIdUploadTagsApiResponse,
        PostSurveyresponsesByResultSchemaIdUploadTagsApiArg
      >({
        query: (queryArg) => ({
          url: `/surveyresponses/${queryArg.resultSchemaId}/$uploadTags`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['SurveyResponses'],
      }),
      postSurveyresultsGetcrosstabdata: build.mutation<
        PostSurveyresultsGetcrosstabdataApiResponse,
        PostSurveyresultsGetcrosstabdataApiArg
      >({
        query: (queryArg) => ({
          url: `/surveyresults/$getcrosstabdata`,
          method: 'POST',
          body: queryArg.crossTabsDownloadRequest,
        }),
        invalidatesTags: ['SurveyResults'],
      }),
      postSurveyresultsGetscorecarddata: build.mutation<
        PostSurveyresultsGetscorecarddataApiResponse,
        PostSurveyresultsGetscorecarddataApiArg
      >({
        query: (queryArg) => ({
          url: `/surveyresults/$getscorecarddata`,
          method: 'POST',
          body: queryArg.scorecardDataRequest,
        }),
        invalidatesTags: ['SurveyResults'],
      }),
      postSurveyresultsGetpenaltyanalysis: build.mutation<
        PostSurveyresultsGetpenaltyanalysisApiResponse,
        PostSurveyresultsGetpenaltyanalysisApiArg
      >({
        query: (queryArg) => ({
          url: `/surveyresults/$getpenaltyanalysis`,
          method: 'POST',
          body: queryArg.penaltyAnalysisRequest,
        }),
        invalidatesTags: ['SurveyResults'],
      }),
      postSurveyresultsGetalienationanalysis: build.mutation<
        PostSurveyresultsGetalienationanalysisApiResponse,
        PostSurveyresultsGetalienationanalysisApiArg
      >({
        query: (queryArg) => ({
          url: `/surveyresults/$getalienationanalysis`,
          method: 'POST',
          body: queryArg.alienationAnalysisRequest,
        }),
        invalidatesTags: ['SurveyResults'],
      }),
      postSurveyReviewReviewAll: build.mutation<
        PostSurveyReviewReviewAllApiResponse,
        PostSurveyReviewReviewAllApiArg
      >({
        query: (queryArg) => ({
          url: `/SurveyReview/review-all`,
          method: 'POST',
          body: queryArg.surveyReviewAllRequest,
        }),
        invalidatesTags: ['SurveyReview'],
      }),
      postTextprocessingByResultSchemaIdStart: build.mutation<
        PostTextprocessingByResultSchemaIdStartApiResponse,
        PostTextprocessingByResultSchemaIdStartApiArg
      >({
        query: (queryArg) => ({
          url: `/textprocessing/${queryArg.resultSchemaId}/$start`,
          method: 'POST',
        }),
        invalidatesTags: ['TextProcessing'],
      }),
      getSurveyConfigsBySurveyConfigIdVariableLogics: build.query<
        GetSurveyConfigsBySurveyConfigIdVariableLogicsApiResponse,
        GetSurveyConfigsBySurveyConfigIdVariableLogicsApiArg
      >({
        query: (queryArg) => ({ url: `/SurveyConfigs/${queryArg.surveyConfigId}/VariableLogics` }),
        providesTags: ['VariableLogics'],
      }),
      putSurveyConfigsBySurveyConfigIdVariableLogicsAndId: build.mutation<
        PutSurveyConfigsBySurveyConfigIdVariableLogicsAndIdApiResponse,
        PutSurveyConfigsBySurveyConfigIdVariableLogicsAndIdApiArg
      >({
        query: (queryArg) => ({
          url: `/SurveyConfigs/${queryArg.surveyConfigId}/VariableLogics/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.variableLogic,
        }),
        invalidatesTags: ['VariableLogics'],
      }),
      deleteSurveyConfigsBySurveyConfigIdVariableLogicsAndId: build.mutation<
        DeleteSurveyConfigsBySurveyConfigIdVariableLogicsAndIdApiResponse,
        DeleteSurveyConfigsBySurveyConfigIdVariableLogicsAndIdApiArg
      >({
        query: (queryArg) => ({
          url: `/SurveyConfigs/${queryArg.surveyConfigId}/VariableLogics/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['VariableLogics'],
      }),
      getSurveyConfigsBySurveyConfigIdVariableLogicsValidation: build.query<
        GetSurveyConfigsBySurveyConfigIdVariableLogicsValidationApiResponse,
        GetSurveyConfigsBySurveyConfigIdVariableLogicsValidationApiArg
      >({
        query: (queryArg) => ({
          url: `/SurveyConfigs/${queryArg.surveyConfigId}/VariableLogics/$validation`,
        }),
        providesTags: ['VariableLogics'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as surveyApi };
export type GetAggregationtypesApiResponse = /** status 200 Success */ AggregationType[];
export type GetAggregationtypesApiArg = void;
export type GetAiGenerationJobByJobIdStatusApiResponse =
  /** status 200 Success */ GenerationJobResponse;
export type GetAiGenerationJobByJobIdStatusApiArg = {
  jobId: string;
};
export type GetBackgroundjoblogsApiResponse = /** status 200 Success */ BackgroundJobLog[];
export type GetBackgroundjoblogsApiArg = void;
export type GetBlocksApiResponse = /** status 200 Success */ BlockSlotsDto[];
export type GetBlocksApiArg = void;
export type PostBlocksApiResponse = /** status 200 Success */ Block;
export type PostBlocksApiArg = {
  block: Block;
};
export type PostBlocksBulkGetApiResponse = /** status 200 Success */ BlockSlotsDto[];
export type PostBlocksBulkGetApiArg = {
  bulkGetRequest: BulkGetRequest;
};
export type PutBlocksByBlockIdApiResponse = /** status 200 Success */ Block;
export type PutBlocksByBlockIdApiArg = {
  blockId: string;
  block: Block;
};
export type DeleteBlocksByBlockIdApiResponse = unknown;
export type DeleteBlocksByBlockIdApiArg = {
  blockId: string;
};
export type GetBlocksQuestionDesignByQuestionDesignIdApiResponse =
  /** status 200 Success */ Block[];
export type GetBlocksQuestionDesignByQuestionDesignIdApiArg = {
  questionDesignId: string;
};
export type GetBlockTypeOptionsApiResponse = /** status 200 Success */ BlockTypeOption[];
export type GetBlockTypeOptionsApiArg = void;
export type PostBlueprintsApiResponse = /** status 200 Success */ Block[];
export type PostBlueprintsApiArg = {
  bulkCreateRequest: BulkCreateRequest;
};
export type PostBlueprintsBulkCreateApiResponse = /** status 200 Success */ Block[];
export type PostBlueprintsBulkCreateApiArg = {
  body: {
    file?: Blob;
  };
};
export type PostLineItemsByLineItemIdCustomTopicsApiResponse =
  /** status 200 Success */ CustomTopic;
export type PostLineItemsByLineItemIdCustomTopicsApiArg = {
  lineItemId: string;
  createCustomTopicRequest: CreateCustomTopicRequest;
};
export type GetSurveyconfigsBySurveyConfigIdDisqualificationlogicsApiResponse =
  /** status 200 Success */ DisqualificationLogic[];
export type GetSurveyconfigsBySurveyConfigIdDisqualificationlogicsApiArg = {
  surveyConfigId: string;
};
export type PutSurveyconfigsBySurveyConfigIdDisqualificationlogicsAndIdApiResponse =
  /** status 200 Success */ DisqualificationLogic;
export type PutSurveyconfigsBySurveyConfigIdDisqualificationlogicsAndIdApiArg = {
  surveyConfigId: string;
  id: string;
  disqualificationLogic: DisqualificationLogic;
};
export type DeleteSurveyconfigsBySurveyConfigIdDisqualificationlogicsAndIdApiResponse = unknown;
export type DeleteSurveyconfigsBySurveyConfigIdDisqualificationlogicsAndIdApiArg = {
  surveyConfigId: string;
  id: string;
};
export type GetSurveyconfigsBySurveyConfigIdDisqualificationlogicsValidationApiResponse =
  /** status 200 Success */ DisqualificationLogicValidationResults;
export type GetSurveyconfigsBySurveyConfigIdDisqualificationlogicsValidationApiArg = {
  surveyConfigId: string;
};
export type GetExternalSurveysApiResponse = /** status 200 Success */ ExternalSurvey[];
export type GetExternalSurveysApiArg = void;
export type PostHighlighterProfileSurveysApiResponse =
  /** status 200 Success */ HighlighterProfileSurvey;
export type PostHighlighterProfileSurveysApiArg = {
  highlighterProfileSurvey: HighlighterProfileSurvey;
};
export type PatchHighlighterProfileSurveysApiResponse =
  /** status 200 Success */ HighlighterProfileSurvey;
export type PatchHighlighterProfileSurveysApiArg = {
  highlighterProfileSurvey: HighlighterProfileSurvey;
};
export type GetHighlighterProfileSurveysApiResponse =
  /** status 200 Success */ HighlighterProfileSurvey[];
export type GetHighlighterProfileSurveysApiArg = {
  externalId?: string;
  vendorName?: string;
  communitySlug?: string;
};
export type PostHighlighterProfileSurveysFinalizeQuestionsApiResponse = unknown;
export type PostHighlighterProfileSurveysFinalizeQuestionsApiArg = {
  finalizeQuestionRequest: FinalizeQuestionRequest;
};
export type GetHighlighterProfileSurveysByIdApiResponse =
  /** status 200 Success */ HighlighterProfileSurvey;
export type GetHighlighterProfileSurveysByIdApiArg = {
  id: string;
};
export type PostLineItemsApiResponse = /** status 200 Success */ LineItemRead;
export type PostLineItemsApiArg = {
  lineItem: LineItem;
};
export type PutLineItemsApiResponse = unknown;
export type PutLineItemsApiArg = {
  lineItem: LineItem;
};
export type DeleteLineItemsByLineItemIdApiResponse = unknown;
export type DeleteLineItemsByLineItemIdApiArg = {
  lineItemId: string;
};
export type PostLineItemsByLineItemIdSetordinalApiResponse = unknown;
export type PostLineItemsByLineItemIdSetordinalApiArg = {
  lineItemId: string;
  setOrdinalRequest: SetOrdinalRequest;
};
export type PostLineItemsBatchApiResponse = /** status 200 Success */ LineItemBatchResponseRead;
export type PostLineItemsBatchApiArg = {
  lineItemBatchRequest: LineItemBatchRequest;
};
export type GetResultContextsByResultContextIdLineitemsApiResponse =
  /** status 200 Success */ LineItemRead[];
export type GetResultContextsByResultContextIdLineitemsApiArg = {
  resultContextId: string;
  scope?: LineItemScope;
};
export type PostResultContextsByResultContextIdLineitemsApiResponse = unknown;
export type PostResultContextsByResultContextIdLineitemsApiArg = {
  resultContextId: string;
  resultContextPopulateRequest: ResultContextPopulateRequest;
};
export type GetResultContextsByResultContextIdQuestioninventoryApiResponse =
  /** status 200 Success */ QuestionInventoryItem[];
export type GetResultContextsByResultContextIdQuestioninventoryApiArg = {
  resultContextId: string;
};
export type GetResultContextsByResultContextIdLineitemsHasanyApiResponse =
  /** status 200 Success */ boolean;
export type GetResultContextsByResultContextIdLineitemsHasanyApiArg = {
  resultContextId: string;
  scope?: LineItemScope;
};
export type GetMaterializedSurveysByMaterializedSurveyIdApiResponse =
  /** status 200 Success */ MaterializedSurveyDto;
export type GetMaterializedSurveysByMaterializedSurveyIdApiArg = {
  materializedSurveyId: string;
};
export type PutMaterializedSurveysByMaterializedSurveyIdApiResponse =
  /** status 200 Success */ MaterializedSurveyDto;
export type PutMaterializedSurveysByMaterializedSurveyIdApiArg = {
  materializedSurveyId: string;
  materializedSurveyDto: MaterializedSurveyDto;
};
export type GetMaterializedSurveysByMaterializedSurveyIdQuestionsApiResponse =
  /** status 200 Success */ Question[];
export type GetMaterializedSurveysByMaterializedSurveyIdQuestionsApiArg = {
  materializedSurveyId: string;
  vendorName?: string;
};
export type GetMaterializedSurveysByMaterializedSurveyIdJsonApiResponse =
  /** status 200 Success */ string;
export type GetMaterializedSurveysByMaterializedSurveyIdJsonApiArg = {
  materializedSurveyId: string;
};
export type GetProjectsByProjectIdMaxPositionsApiResponse =
  /** status 200 Success */ MaxPositionsResponse;
export type GetProjectsByProjectIdMaxPositionsApiArg = {
  projectId: number;
};
export type GetPhotoqcreviewApiResponse = /** status 200 Success */ PhotoQcReviewDtoPagedResult;
export type GetPhotoqcreviewApiArg = {
  pageIndex?: number;
  pageSize?: number;
  qualityRating?: string;
  from?: string;
  to?: string;
};
export type PostQualitycontrolGetreportApiResponse = /** status 200 Success */ QualityControlReport;
export type PostQualitycontrolGetreportApiArg = {
  body: string[];
};
export type GetQualitycontrolResponsedetailsBySurveyResponseIdApiResponse =
  /** status 200 Success */ ResponseDetails;
export type GetQualitycontrolResponsedetailsBySurveyResponseIdApiArg = {
  surveyResponseId: string;
};
export type PostQualitycontrolSubmitReviewApiResponse = unknown;
export type PostQualitycontrolSubmitReviewApiArg = {
  submitReviewPayload: SubmitReviewPayload;
};
export type PostQualitycontrolSetAnswerExcludedApiResponse = unknown;
export type PostQualitycontrolSetAnswerExcludedApiArg = {
  setAnswerExcludedPayload: SetAnswerExcludedPayload;
};
export type GetQuestionChoicesByChoiceIdApiResponse = /** status 200 Success */ QuestionChoice;
export type GetQuestionChoicesByChoiceIdApiArg = {
  choiceId: string;
};
export type PatchQuestionChoicesByChoiceIdApiResponse = /** status 200 Success */ QuestionChoice;
export type PatchQuestionChoicesByChoiceIdApiArg = {
  choiceId: string;
  patchQuestionChoiceRequest: PatchQuestionChoiceRequest;
};
export type PostQuestionDesignsByQuestionDesignIdChoicesAssignApiResponse =
  /** status 200 Success */ QuestionDesignChoice[];
export type PostQuestionDesignsByQuestionDesignIdChoicesAssignApiArg = {
  questionDesignId: string;
  body: QuestionDesignChoice[];
};
export type GetQuestionDesignsByQuestionDesignIdChoicesApiResponse =
  /** status 200 Success */ QuestionDesignChoice[];
export type GetQuestionDesignsByQuestionDesignIdChoicesApiArg = {
  questionDesignId: string;
};
export type GetQuestionDesignsApiResponse = /** status 200 Success */ QuestionDesign[];
export type GetQuestionDesignsApiArg = void;
export type PostQuestionDesignsApiResponse = /** status 200 Success */ QuestionDesign;
export type PostQuestionDesignsApiArg = {
  questionDesign: QuestionDesign;
};
export type PutQuestionDesignsByQuestionDesignIdApiResponse =
  /** status 200 Success */ QuestionDesign;
export type PutQuestionDesignsByQuestionDesignIdApiArg = {
  questionDesignId: string;
  questionDesign: QuestionDesign;
};
export type GetQuestionsApiResponse = /** status 200 Success */ Question[];
export type GetQuestionsApiArg = {
  surveyId?: string;
  resultSchemaId?: string;
};
export type PostQuestionsByQuestionIdConvertApiResponse = unknown;
export type PostQuestionsByQuestionIdConvertApiArg = {
  questionId: string;
  convertQuestionTypeRequest: ConvertQuestionTypeRequest;
};
export type GetQuestionsByQuestionIdApiResponse = /** status 200 Success */ Question;
export type GetQuestionsByQuestionIdApiArg = {
  questionId: string;
};
export type PatchQuestionsByQuestionIdApiResponse = /** status 200 Success */ Question;
export type PatchQuestionsByQuestionIdApiArg = {
  questionId: string;
  patchQuestionRequest: PatchQuestionRequest;
};
export type GetResultContextsApiResponse = /** status 200 Success */ ResultContextDto[];
export type GetResultContextsApiArg = void;
export type PostResultContextsApiResponse = /** status 200 Success */ ResultContextDto;
export type PostResultContextsApiArg = {
  resultContextDto: ResultContextDto;
};
export type PostResultContextsByResultContextIdDeletesummariesApiResponse = unknown;
export type PostResultContextsByResultContextIdDeletesummariesApiArg = {
  resultContextId: string;
};
export type GetResultContextsByResultContextIdSummarycountApiResponse =
  /** status 200 Success */ number;
export type GetResultContextsByResultContextIdSummarycountApiArg = {
  resultContextId: string;
};
export type PostResultContextsByResultContextIdResetDashboardApiResponse =
  /** status 200 Success */ ResetDashboardResponse;
export type PostResultContextsByResultContextIdResetDashboardApiArg = {
  resultContextId: string;
};
export type GetResultContextsByResultContextIdScorecardentriesApiResponse =
  /** status 200 Success */ ScoreCardEntryRead[];
export type GetResultContextsByResultContextIdScorecardentriesApiArg = {
  resultContextId: string;
  scope?: LineItemScope;
};
export type PostScoreCardEntriesApiResponse = /** status 200 Success */ ScoreCardEntryRead;
export type PostScoreCardEntriesApiArg = {
  scoreCardEntry: ScoreCardEntry;
};
export type PutScoreCardEntriesApiResponse = unknown;
export type PutScoreCardEntriesApiArg = {
  scoreCardEntry: ScoreCardEntry;
};
export type PostScoreCardEntriesBatchApiResponse =
  /** status 200 Success */ ScoreCardEntryBatchResponseRead;
export type PostScoreCardEntriesBatchApiArg = {
  scoreCardEntryBatchRequest: ScoreCardEntryBatchRequest;
};
export type PatchScoreCardEntriesUpdateOrdinalsApiResponse =
  /** status 200 Success */ ScoreCardEntryRead[];
export type PatchScoreCardEntriesUpdateOrdinalsApiArg = {
  body: ScoreCardEntry[];
};
export type DeleteScoreCardEntriesByScorecardEntryIdApiResponse = unknown;
export type DeleteScoreCardEntriesByScorecardEntryIdApiArg = {
  scorecardEntryId: string;
};
export type GetSegmentsResultcontextsByResultContextIdEnabledSegmentsApiResponse =
  /** status 200 Success */ Segment[];
export type GetSegmentsResultcontextsByResultContextIdEnabledSegmentsApiArg = {
  resultContextId: string;
};
export type DeleteSegmentsByIdApiResponse = unknown;
export type DeleteSegmentsByIdApiArg = {
  id: string;
};
export type PostSegmentsResultcontextsByResultContextIdBackfillDefaultSegmentsApiResponse = unknown;
export type PostSegmentsResultcontextsByResultContextIdBackfillDefaultSegmentsApiArg = {
  _?: string;
  resultContextId: string;
  createDefaultSegmentsRequest: CreateDefaultSegmentsRequest;
};
export type GetSurveyconfigsBySurveyConfigIdShowlogicsApiResponse =
  /** status 200 Success */ ShowLogic[];
export type GetSurveyconfigsBySurveyConfigIdShowlogicsApiArg = {
  surveyConfigId: string;
};
export type GetSurveyconfigsBySurveyConfigIdShowlogicsAndIdApiResponse =
  /** status 200 Success */ ShowLogic;
export type GetSurveyconfigsBySurveyConfigIdShowlogicsAndIdApiArg = {
  surveyConfigId: string;
  id: string;
};
export type PutSurveyconfigsBySurveyConfigIdShowlogicsAndIdApiResponse =
  /** status 200 Success */ ShowLogic;
export type PutSurveyconfigsBySurveyConfigIdShowlogicsAndIdApiArg = {
  surveyConfigId: string;
  id: string;
  showLogic: ShowLogic;
};
export type DeleteSurveyconfigsBySurveyConfigIdShowlogicsAndIdApiResponse = unknown;
export type DeleteSurveyconfigsBySurveyConfigIdShowlogicsAndIdApiArg = {
  surveyConfigId: string;
  id: string;
};
export type GetSurveyconfigsBySurveyConfigIdShowlogicsValidationApiResponse =
  /** status 200 Success */ ShowLogicValidationResults;
export type GetSurveyconfigsBySurveyConfigIdShowlogicsValidationApiArg = {
  surveyConfigId: string;
};
export type GetBlocksByBlockIdSlotsApiResponse = /** status 200 Success */ Slot[];
export type GetBlocksByBlockIdSlotsApiArg = {
  blockId: string;
};
export type PostBlocksByBlockIdSlotsAssignApiResponse = /** status 200 Success */ Slot[];
export type PostBlocksByBlockIdSlotsAssignApiArg = {
  blockId: string;
  body: Slot[];
};
export type PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsCreateMatrixGroupApiResponse =
  /** status 200 Success */ SurveyConfigBlockGroup;
export type PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsCreateMatrixGroupApiArg = {
  surveyConfigId: string;
  matrixBlockRequest: MatrixBlockRequest;
};
export type PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdAddMatrixBlockApiResponse =
  /** status 200 Success */ SurveyConfigBlockGroup;
export type PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdAddMatrixBlockApiArg =
  {
    surveyConfigId: string;
    surveyConfigBlockGroupId: string;
    addMatrixBlockRequest: AddMatrixBlockRequest;
  };
export type GetSurveyConfigBlockGroupsApiResponse =
  /** status 200 Success */ SurveyConfigBlockGroup[];
export type GetSurveyConfigBlockGroupsApiArg = {
  surveyConfigId?: string;
};
export type DeleteSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdApiResponse =
  unknown;
export type DeleteSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdApiArg =
  {
    surveyConfigId: string;
    surveyConfigBlockGroupId: string;
  };
export type PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdNameApiResponse =
  /** status 200 Success */ SurveyConfigBlockGroup;
export type PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdNameApiArg =
  {
    surveyConfigId: string;
    surveyConfigBlockGroupId: string;
    updateSurveyConfigBlockGroupNameRequest: UpdateSurveyConfigBlockGroupNameRequest;
  };
export type PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdAreQuestionsRequiredApiResponse =
  /** status 200 Success */ SurveyConfigBlockGroup;
export type PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdAreQuestionsRequiredApiArg =
  {
    surveyConfigId: string;
    surveyConfigBlockGroupId: string;
    updateSurveyConfigBlockGroupAreQuestionsRequiredRequest: UpdateSurveyConfigBlockGroupAreQuestionsRequiredRequest;
  };
export type PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdBehaviorsApiResponse =
  /** status 200 Success */ SurveyConfigBlockGroup;
export type PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdBehaviorsApiArg =
  {
    surveyConfigId: string;
    surveyConfigBlockGroupId: string;
    body: BlockGroupBehaviorValue[];
  };
export type PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdBlockIdsApiResponse =
  /** status 200 Success */ SurveyConfigBlockGroup;
export type PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdBlockIdsApiArg =
  {
    surveyConfigId: string;
    surveyConfigBlockGroupId: string;
    body: string[];
  };
export type PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdPreviewApiResponse =
  /** status 200 Success */ PreviewResponse;
export type PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdPreviewApiArg =
  {
    surveyConfigId: string;
    surveyConfigBlockGroupId: string;
  };
export type PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdCloneApiResponse =
  /** status 200 Success */ SurveyConfigBlockGroup;
export type PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdCloneApiArg =
  {
    surveyConfigId: string;
    surveyConfigBlockGroupId: string;
  };
export type GetSurveyConfigsBySurveyConfigIdBlocksApiResponse =
  /** status 200 Success */ SurveyConfigBlock[];
export type GetSurveyConfigsBySurveyConfigIdBlocksApiArg = {
  surveyConfigId: string;
};
export type PostSurveyConfigsBySurveyConfigIdBlocksAndSurveyConfigBlockIdCloneApiResponse =
  /** status 200 Success */ SurveyConfigBlock;
export type PostSurveyConfigsBySurveyConfigIdBlocksAndSurveyConfigBlockIdCloneApiArg = {
  surveyConfigId: string;
  surveyConfigBlockId: string;
};
export type GetSurveyConfigsBySurveyConfigIdQuestionsApiResponse =
  /** status 200 Success */ Question[];
export type GetSurveyConfigsBySurveyConfigIdQuestionsApiArg = {
  surveyConfigId: string;
};
export type GetSurveyConfigsBySurveyConfigIdResponseTagCountsApiResponse =
  /** status 200 Success */ ResponseTagCount[];
export type GetSurveyConfigsBySurveyConfigIdResponseTagCountsApiArg = {
  surveyConfigId: string;
};
export type GetSurveyConfigsApiResponse = /** status 200 Success */ SurveyConfigRead[];
export type GetSurveyConfigsApiArg = void;
export type PostSurveyConfigsConfigureApiResponse = /** status 200 Success */ SurveyConfigRead;
export type PostSurveyConfigsConfigureApiArg = {
  configureSurveyRequest: ConfigureSurveyRequest;
};
export type PostSurveyConfigsBySurveyConfigIdStartreportingApiResponse = unknown;
export type PostSurveyConfigsBySurveyConfigIdStartreportingApiArg = {
  surveyConfigId: string;
};
export type GetSurveyConfigsBySurveyConfigIdDefinitionApiResponse = unknown;
export type GetSurveyConfigsBySurveyConfigIdDefinitionApiArg = {
  surveyConfigId: string;
};
export type PostSurveyConfigsBySurveyConfigIdExportDocxApiResponse = unknown;
export type PostSurveyConfigsBySurveyConfigIdExportDocxApiArg = {
  surveyConfigId: string;
  projectId?: number;
};
export type PostSurveyConfigsBySurveyConfigIdResetresultschemaApiResponse = unknown;
export type PostSurveyConfigsBySurveyConfigIdResetresultschemaApiArg = {
  surveyConfigId: string;
};
export type PostSurveyConfigsBySurveyConfigIdGenerateTestResponsesApiResponse =
  /** status 200 Success */ GenerationJobResponse;
export type PostSurveyConfigsBySurveyConfigIdGenerateTestResponsesApiArg = {
  surveyConfigId: string;
  generateTestResponsesRequest: GenerateTestResponsesRequest;
};
export type PostSurveyingestorsByVendorNameResponsesApiResponse = unknown;
export type PostSurveyingestorsByVendorNameResponsesApiArg = {
  vendorName: string;
  vendorSurveyResponse: VendorSurveyResponse;
};
export type GetSurveyresponsesApiResponse = /** status 200 Success */ SurveyResponse[];
export type GetSurveyresponsesApiArg = {
  /** Vendor `survey.survey_response.survey_id` when identifying the survey by vendor id */
  surveyId?: string;
  /** Optional filter to one highlighter */
  highlighterId?: string;
  /** `survey.survey_config.id` when identifying the survey by config row id instead */
  surveyConfigId?: string;
};
export type DeleteSurveyresponsesApiResponse = unknown;
export type DeleteSurveyresponsesApiArg = {
  resultSchemaId?: string;
  highlighterId?: string;
};
export type GetSurveyresponsesByIdSurveyConfigApiResponse =
  /** status 200 Success */ SurveyConfigRead;
export type GetSurveyresponsesByIdSurveyConfigApiArg = {
  id: string;
};
export type PostSurveyresponsesByResultSchemaIdUploadTagsApiResponse = unknown;
export type PostSurveyresponsesByResultSchemaIdUploadTagsApiArg = {
  resultSchemaId: string;
  body: {
    ContentType?: string;
    ContentDisposition?: string;
    Headers?: {
      [key: string]: string[];
    };
    Length?: number;
    Name?: string;
    FileName?: string;
  };
};
export type PostSurveyresultsGetcrosstabdataApiResponse = /** status 200 Success */ CrossTabsDto;
export type PostSurveyresultsGetcrosstabdataApiArg = {
  crossTabsDownloadRequest: CrossTabsDownloadRequest;
};
export type PostSurveyresultsGetscorecarddataApiResponse =
  /** status 200 Success */ ScorecardDataDto;
export type PostSurveyresultsGetscorecarddataApiArg = {
  scorecardDataRequest: ScorecardDataRequest;
};
export type PostSurveyresultsGetpenaltyanalysisApiResponse =
  /** status 200 Success */ PenaltyAnalysisDto;
export type PostSurveyresultsGetpenaltyanalysisApiArg = {
  penaltyAnalysisRequest: PenaltyAnalysisRequest;
};
export type PostSurveyresultsGetalienationanalysisApiResponse =
  /** status 200 Success */ AlienationAnalysisResponse;
export type PostSurveyresultsGetalienationanalysisApiArg = {
  alienationAnalysisRequest: AlienationAnalysisRequest;
};
export type PostSurveyReviewReviewAllApiResponse =
  /** status 200 Success */ SurveyReviewAllResultRead;
export type PostSurveyReviewReviewAllApiArg = {
  surveyReviewAllRequest: SurveyReviewAllRequest;
};
export type PostTextprocessingByResultSchemaIdStartApiResponse = unknown;
export type PostTextprocessingByResultSchemaIdStartApiArg = {
  resultSchemaId: string;
};
export type GetSurveyConfigsBySurveyConfigIdVariableLogicsApiResponse =
  /** status 200 Success */ VariableLogic[];
export type GetSurveyConfigsBySurveyConfigIdVariableLogicsApiArg = {
  surveyConfigId: string;
};
export type PutSurveyConfigsBySurveyConfigIdVariableLogicsAndIdApiResponse =
  /** status 200 Success */ VariableLogic;
export type PutSurveyConfigsBySurveyConfigIdVariableLogicsAndIdApiArg = {
  surveyConfigId: string;
  id: string;
  variableLogic: VariableLogic;
};
export type DeleteSurveyConfigsBySurveyConfigIdVariableLogicsAndIdApiResponse = unknown;
export type DeleteSurveyConfigsBySurveyConfigIdVariableLogicsAndIdApiArg = {
  surveyConfigId: string;
  id: string;
};
export type GetSurveyConfigsBySurveyConfigIdVariableLogicsValidationApiResponse =
  /** status 200 Success */ VariableLogicValidationResults;
export type GetSurveyConfigsBySurveyConfigIdVariableLogicsValidationApiArg = {
  surveyConfigId: string;
};
export type AggregationType = {
  slug?: string | null;
  display?: string | null;
  aggregationGroup?: string | null;
  showInCrossTab?: boolean;
  isProportion?: boolean;
};
export type GenerationJobResponse = {
  jobId?: string | null;
  status?: string | null;
  generatedResponseIds?: string[] | null;
  errorMessage?: string | null;
  completedCount?: number;
};
export type BackgroundJobLog = {
  id?: string;
  jobName?: string | null;
  createdAt?: string;
  success?: boolean;
  details?: any | null;
};
export type Slot = {
  id?: string | null;
  blockId?: string;
  key?: string | null;
  label?: string | null;
  placeholder?: string | null;
  slotType?: string | null;
  displayOrder?: number;
  slotValueOptions?: string[] | null;
  canApplyAllWithinSurveys?: boolean;
  isRequired?: boolean;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
};
export type QuestionDesign = {
  id?: string;
  name?: string | null;
  questionType?: string | null;
  questionText?: string | null;
  descriptionText?: string | null;
  descriptionImageUrl?: string | null;
  isArchived?: boolean;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
};
export type BlockBehavior = {
  id?: string | null;
  blockId?: string | null;
  questionBehavior?: string | null;
  canCustomerEdit?: boolean;
  defaultValue?: boolean;
  defaultNumericValue?: number | null;
  defaultStringValue?: string | null;
};
export type BlockSlotsDto = {
  slots?: Slot[] | null;
  id?: string;
  description?: string | null;
  name?: string | null;
  externalId?: string | null;
  questionDesign?: QuestionDesign;
  internalName?: string | null;
  isArchived?: boolean;
  behaviors?: BlockBehavior[] | null;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
};
export type Block = {
  id?: string;
  description?: string | null;
  name?: string | null;
  externalId?: string | null;
  questionDesign?: QuestionDesign;
  internalName?: string | null;
  isArchived?: boolean;
  behaviors?: BlockBehavior[] | null;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
};
export type BulkGetRequest = {
  ids?: string[] | null;
  names?: string[] | null;
};
export type BlockType = {
  id?: string;
  name?: string | null;
};
export type BlockTypeOption = {
  name?: string | null;
  isDefault?: boolean;
  isRequired?: boolean;
  optionalBlockType?: BlockType;
};
export type QuestionDesignChoice = {
  id?: string | null;
  questionDesignId?: string;
  label?: string | null;
  ordinal?: number;
  type?: string | null;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
};
export type BulkCreateBlocksAndQuestionDesignsDto = {
  randomizeChoices?: boolean;
  includeOtherChoice?: boolean;
  questionChoices?: QuestionDesignChoice[] | null;
  slots?: Slot[] | null;
  id?: string;
  description?: string | null;
  name?: string | null;
  externalId?: string | null;
  questionDesign?: QuestionDesign;
  internalName?: string | null;
  isArchived?: boolean;
  behaviors?: BlockBehavior[] | null;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
};
export type BulkCreateRequest = {
  bulkBlocks?: BulkCreateBlocksAndQuestionDesignsDto[] | null;
};
export type CustomTopic = {
  id?: string;
  lineItemId?: string;
  name?: string | null;
  status?: string | null;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
};
export type CreateCustomTopicRequest = {
  name?: string | null;
};
export type SurveyExpression = {
  id?: string | null;
  kind?: string | null;
  op?: string | null;
  children?: SurveyExpression[] | null;
  surveyConfigQuestionId?: string | null;
  variableName?: string | null;
  operandInt?: number | null;
  operandString?: string | null;
  operandChoices?: string[] | null;
};
export type DisqualificationLogic = {
  id?: string;
  surveyConfigQuestionId?: string;
  expressionTree?: SurveyExpression;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
};
export type DisqualificationValidation = {
  surveyConfigBlockId?: string;
  messages?: string[] | null;
};
export type DisqualificationLogicValidationResults = {
  questionValidationFailures?: DisqualificationValidation[] | null;
};
export type ExternalSurvey = {
  id?: string | null;
  vendorName?: string | null;
  externalId?: string | null;
  resultSchemaId?: string;
};
export type QuestionLabel = {
  questionText?: string | null;
  label?: string | null;
};
export type QuestionChoice = {
  id?: string | null;
  externalId?: string | null;
  label?: string | null;
  questionId?: string | null;
  ordinal?: number;
  imageUrl?: string | null;
};
export type QuestionScaleProperties = {
  id?: string | null;
  questionId?: string | null;
  scaleStart?: number;
  scaleEnd?: number;
  startLabel?: string | null;
  middleLabel?: string | null;
  endLabel?: string | null;
  appearance?: string | null;
};
export type Question = {
  id?: string | null;
  resultSchemaId?: string | null;
  questionType?: string | null;
  allowMultipleSelections?: boolean;
  label?: string | null;
  externalId?: string | null;
  choices?: QuestionChoice[] | null;
  scaleProperties?: QuestionScaleProperties;
  ordinal?: number;
  createdAt?: string | null;
  updatedAt?: string | null;
};
export type HighlighterProfileSurvey = {
  id?: string | null;
  name?: string | null;
  externalId?: string | null;
  vendorName?: string | null;
  resultSchemaId?: string;
  questionLabels?: QuestionLabel[] | null;
  visibleToResults?: boolean | null;
  communitySlug?: string | null;
  questions?: Question[] | null;
  isPublished?: boolean | null;
};
export type FinalizeQuestionRequest = {
  vendorName?: string | null;
  externalId?: string | null;
  resultSchemaId?: string;
};
export type LinkedQuestion = {
  question?: Question;
  surveyConfigId?: string | null;
};
export type LineItemScope = 'within_touchpoint' | 'cross_touchpoint';
export type LineItem = {
  id?: string | null;
  label?: string | null;
  questions?: LinkedQuestion[] | null;
  ordinal?: number;
  isOverallLikingQuestion?: boolean;
  isJarQuestion?: boolean;
  /** Designates this line item's linked question(s) as a preference question, so answer-choice
    significance testing applies. Gated at storage on the question being categorical or ranking
    with mutually exclusive answer choices. See EPD-1550. */
  isPreferenceQuestion?: boolean;
  resultContextId?: string;
  scope?: LineItemScope;
  hasAiLabelFallback?: boolean;
  createdAt?: string | null;
  updatedAt?: string | null;
  createdBy?: string | null;
  updatedBy?: string | null;
};
export type LineItemRead = {
  id?: string | null;
  label?: string | null;
  /** If this is empty it is because the lineItem can not be "aggregated" by a mathematical calculation, ie its a text question.
    Should come from SurveyApi.SharedTypes.ScoreCard.AggregationGroups */
  aggregationGroup?: string | null;
  /** The metric slugs suggested by default for this line item, derived from its
    SurveyApi.LineItems.Models.LineItem.AggregationGroup together with SurveyApi.LineItems.Models.LineItem.IsJarQuestion and
    SurveyApi.LineItems.Models.LineItem.IsOverallLikingQuestion. Empty when the line item has no eligible aggregation
    group. The rules live once in SurveyApi.SharedTypes.ScoreCards.SuggestedMetrics so the
    editor and any server-side scorecard population share a single definition. */
  suggestedMetrics?: string[] | null;
  questions?: LinkedQuestion[] | null;
  ordinal?: number;
  isOverallLikingQuestion?: boolean;
  isJarQuestion?: boolean;
  /** Designates this line item's linked question(s) as a preference question, so answer-choice
    significance testing applies. Gated at storage on the question being categorical or ranking
    with mutually exclusive answer choices. See EPD-1550. */
  isPreferenceQuestion?: boolean;
  resultContextId?: string;
  scope?: LineItemScope;
  hasAiLabelFallback?: boolean;
  createdAt?: string | null;
  updatedAt?: string | null;
  createdBy?: string | null;
  updatedBy?: string | null;
};
export type SetOrdinalRequest = {
  ordinal?: number;
};
export type LineItemBatchResult = {
  success?: boolean;
  lineItem?: LineItem;
  errorMessage?: string | null;
  errorType?: string | null;
  lineItemId?: string | null;
};
export type LineItemBatchResultRead = {
  success?: boolean;
  lineItem?: LineItemRead;
  errorMessage?: string | null;
  errorType?: string | null;
  lineItemId?: string | null;
};
export type LineItemBatchResponse = {
  success?: boolean;
  message?: string | null;
  items?: LineItemBatchResult[] | null;
  totalRequested?: number;
  successful?: number;
  failed?: number;
};
export type LineItemBatchResponseRead = {
  success?: boolean;
  message?: string | null;
  items?: LineItemBatchResultRead[] | null;
  totalRequested?: number;
  successful?: number;
  failed?: number;
};
export type LineItemBatchRequest = {
  lineItems?: LineItem[] | null;
};
export type LineItemBatchRequestRead = {
  lineItems?: LineItemRead[] | null;
};
export type ResultContextPopulateRequest = {
  surveyConfigId?: string;
};
export type InventoryLinkedQuestion = {
  questionId?: string;
  label?: string | null;
  questionType?: string | null;
  surveyConfigId?: string | null;
  allowMultipleSelections?: boolean;
  scaleStart?: number | null;
  scaleEnd?: number | null;
  startLabel?: string | null;
  middleLabel?: string | null;
  endLabel?: string | null;
  choiceCount?: number | null;
};
export type QuestionInventoryItem = {
  lineItemId?: string;
  label?: string | null;
  ordinal?: number;
  isJarQuestion?: boolean;
  isOverallLikingQuestion?: boolean;
  isPreferenceQuestion?: boolean;
  responseCount?: number;
  scope?: LineItemScope;
  linkedQuestions?: InventoryLinkedQuestion[] | null;
};
export type MaterializedSurveyGroupData = {
  ids?: string[] | null;
  shouldShuffle?: boolean;
};
export type MaterializedSurveyMetadata = {
  groupData?: MaterializedSurveyGroupData[] | null;
};
export type MaterializedSurveyDto = {
  id?: string | null;
  vendorName?: string | null;
  json?: string | null;
  metadata?: MaterializedSurveyMetadata;
  isLatched?: boolean;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
};
export type MaxPositionsResponse = {
  maxPositions?: number;
};
export type PhotoQcReviewDto = {
  id?: string;
  photoUrl?: string | null;
  qualityRating?: string | null;
  qualityJustification?: string | null;
  surveyName?: string | null;
  questionText?: string | null;
  submittedAt?: string;
};
export type PhotoQcReviewDtoPagedResult = {
  items?: PhotoQcReviewDto[] | null;
  totalCount?: number;
  pageIndex?: number;
  pageSize?: number;
};
export type ResponseStatus = {
  status?: string | null;
  surveyResponseId?: string;
};
export type RespondentReview = {
  highlighterId?: string;
  surveyReviews?: {
    [key: string]: ResponseStatus;
  } | null;
  updatedAt?: string | null;
};
export type Header = {
  dataKey?: string | null;
  label?: string | null;
};
export type QualityControlReport = {
  statuses?: RespondentReview[] | null;
  headers?: Header[] | null;
};
export type File = {
  filename?: string | null;
  url?: string | null;
  downloadUrl?: string | null;
};
export type QuestionResponse = {
  question?: string | null;
  questionType?: string | null;
  answerDisplay?: string | null;
  answerFile?: File;
  flagged?: boolean;
  excluded?: boolean;
  answerId?: string | null;
  isMultiSelect?: boolean;
  questionDetails?: Question;
  qualityRating?: string | null;
  qualityJustification?: string | null;
};
export type ResponseReview = {
  comment?: string | null;
  createdBy?: string | null;
  createdAt?: string;
  answerId?: string | null;
  reviewStatus?: string | null;
  justification?: string | null;
};
export type ResponseDetails = {
  responses?: QuestionResponse[] | null;
  responseTags?: string[] | null;
  responseReviewEntries?: ResponseReview[] | null;
  surveyDuration?: string;
  surveyResponseTime?: string | null;
  recruitingTestGroup?: string | null;
  highlighterId?: string;
};
export type SubmitReviewPayload = {
  surveyResponseIds?: string[] | null;
  highlighterIds?: string[] | null;
  surveyId?: string | null;
  comment?: string | null;
  justification?: string | null;
  status?: string | null;
  answerId?: string | null;
  broadcastReviewData?: boolean;
  broadcastReviewStatus?: boolean;
  dontOverrideDisqualified?: boolean;
};
export type SetAnswerExcludedPayload = {
  answerId?: string;
  excluded?: boolean;
};
export type PatchQuestionChoiceRequest = {
  label?: string | null;
  ordinal?: number | null;
};
export type ConvertQuestionTypeRequest = {
  newQuestionType?: string | null;
};
export type PatchQuestionRequest = {
  label?: string | null;
  ordinal?: number | null;
};
export type ResultContextDto = {
  id?: string;
  description?: string | null;
};
export type ResetDashboardResponse = {
  scorecardEntriesDeleted?: number;
  segmentsDeleted?: number;
  lineItemsDeleted?: number;
};
export type ScoreCardEntry = {
  /** Should be set to SurveyApi.SharedTypes.ScoreCard.AggregationTypes */
  aggregationType?: string | null;
  createdAt?: string | null;
  id?: string | null;
  lineItem?: LineItem;
  ordinal?: number;
  resultContextId?: string | null;
  updatedAt?: string | null;
  createdBy?: string | null;
  updatedBy?: string | null;
};
export type ScoreCardEntryRead = {
  /** Should be set to SurveyApi.SharedTypes.ScoreCard.AggregationTypes */
  aggregationType?: string | null;
  createdAt?: string | null;
  id?: string | null;
  lineItem?: LineItemRead;
  ordinal?: number;
  resultContextId?: string | null;
  updatedAt?: string | null;
  createdBy?: string | null;
  updatedBy?: string | null;
};
export type ScoreCardEntryBatchResult = {
  success?: boolean;
  entry?: ScoreCardEntry;
  errorMessage?: string | null;
  errorType?: string | null;
  scoreCardEntryId?: string | null;
};
export type ScoreCardEntryBatchResultRead = {
  success?: boolean;
  entry?: ScoreCardEntryRead;
  errorMessage?: string | null;
  errorType?: string | null;
  scoreCardEntryId?: string | null;
};
export type ScoreCardEntryBatchResponse = {
  success?: boolean;
  message?: string | null;
  items?: ScoreCardEntryBatchResult[] | null;
  totalRequested?: number;
  successful?: number;
  failed?: number;
};
export type ScoreCardEntryBatchResponseRead = {
  success?: boolean;
  message?: string | null;
  items?: ScoreCardEntryBatchResultRead[] | null;
  totalRequested?: number;
  successful?: number;
  failed?: number;
};
export type ScoreCardEntryBatchRequest = {
  entries?: ScoreCardEntry[] | null;
};
export type ScoreCardEntryBatchRequestRead = {
  entries?: ScoreCardEntryRead[] | null;
};
export type SegmentRule = {
  kind?: string | null;
  questionId?: string | null;
  logicOp?: string | null;
  number?: number | null;
  questionChoices?: string[] | null;
  numberChoices?: number[] | null;
  responseTags?: string[] | null;
  responseTagResultSchemaId?: string | null;
};
export type SegmentRuleGroup = {
  rules?: SegmentRule[] | null;
  name?: string | null;
  combineOp?: string | null;
};
export type Segment = {
  ruleGroups?: SegmentRuleGroup[] | null;
  id?: string | null;
  resultContextId?: string;
  name?: string | null;
  combineOp?: string | null;
  enabled?: boolean;
  createdAt?: string;
  createdBy?: string | null;
  updatedBy?: string | null;
};
export type CreateDefaultSegmentsRequest = {
  resultContextId?: string;
  communitySlug?: string | null;
};
export type ShowLogic = {
  id?: string;
  surveyConfigQuestionId?: string;
  expressionTree?: SurveyExpression;
};
export type QuestionValidation = {
  surveyConfigBlockId?: string;
  messages?: string[] | null;
};
export type ShowLogicValidationResults = {
  questionValidationFailures?: QuestionValidation[] | null;
};
export type BlockGroupBehaviorValue = {
  id?: string | null;
  blockGroupBehaviorId?: string | null;
  surveyConfigBlockGroupId?: string;
  canCustomerEdit?: boolean;
  blockGroupBehavior?: string | null;
  value?: boolean;
};
export type GroupType = 'Generic' | 'Matrix';
export type SurveyConfigBlockGroup = {
  id?: string | null;
  name?: string | null;
  surveyConfigBlockIds?: string[] | null;
  behaviors?: BlockGroupBehaviorValue[] | null;
  groupType?: GroupType;
};
export type ConfigureSlotValueRequest = {
  slotId?: string;
  value?: string | null;
  assetId?: string | null;
  externalUrl?: string | null;
};
export type MatrixBlockRequest = {
  matrixBlockId?: string;
  ordinal?: number;
  slots?: ConfigureSlotValueRequest[] | null;
};
export type AddMatrixBlockRequest = {
  slots?: ConfigureSlotValueRequest[] | null;
};
export type UpdateSurveyConfigBlockGroupNameRequest = {
  name?: string | null;
};
export type UpdateSurveyConfigBlockGroupAreQuestionsRequiredRequest = {
  areQuestionsRequired?: boolean;
};
export type PreviewResponse = {
  externalId?: string | null;
  vendorName?: string | null;
};
export type BlockBehaviorValue = {
  id?: string | null;
  blockBehaviorId?: string | null;
  surveyConfigBlockId?: string;
  value?: boolean;
  canCustomerEdit?: boolean;
  questionBehavior?: string | null;
  numericValue?: number | null;
  stringValue?: string | null;
};
export type CompositeSlot = {
  slotValueId?: string | null;
  slotId?: string;
  key?: string | null;
  value?: string | null;
  slotType?: string | null;
  assetId?: string | null;
  externalUrl?: string | null;
  label?: string | null;
  placeholder?: string | null;
  slotValueOptions?: string[] | null;
  canApplyAllWithinSurveys?: boolean;
  isRequired?: boolean;
};
export type SurveyConfigQuestion = {
  id?: string;
  name?: string | null;
  showLogicId?: string | null;
  disqualificationLogicId?: string | null;
  questionDesign?: QuestionDesign;
};
export type SurveyConfigQuestionChoice = {
  id?: string;
  surveyConfigQuestionId?: string;
  questionDesignChoice?: QuestionDesignChoice;
  assetId?: string | null;
  externalUrl?: string | null;
  altText?: string | null;
};
export type SurveyConfigBlock = {
  id?: string | null;
  surveyConfigId?: string;
  surveyDesignBlockId?: string | null;
  block?: Block;
  behaviors?: BlockBehaviorValue[] | null;
  slots?: CompositeSlot[] | null;
  ordinal?: number;
  isRequired?: boolean;
  areQuestionsRequired?: boolean;
  isDefault?: boolean;
  blockType?: BlockType;
  surveyConfigBlockGroupId?: string | null;
  surveyConfigQuestion?: SurveyConfigQuestion;
  surveyConfigQuestionChoices?: SurveyConfigQuestionChoice[] | null;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
  moduleId?: string | null;
  internalName?: string | null;
};
export type ResponseTagCount = {
  tag?: string | null;
  count?: number;
};
export type SurveyConfig = {
  id?: string | null;
  surveyDesignId?: string | null;
  displayName?: string | null;
  internalName?: string | null;
  resultSchemaId?: string | null;
  externalId?: string | null;
  vendorName?: string | null;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
  durationDays?: number;
};
export type SurveyConfigRead = {
  id?: string | null;
  surveyDesignId?: string | null;
  displayName?: string | null;
  internalName?: string | null;
  resultSchemaId?: string | null;
  externalId?: string | null;
  vendorName?: string | null;
  externalUrl?: string | null;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
  durationDays?: number;
};
export type ConfigureBlockRequest = {
  blockId?: string;
  surveyDesignBlockId?: string | null;
  moduleId?: string | null;
  areQuestionsRequired?: boolean;
  internalName?: string | null;
  slots?: ConfigureSlotValueRequest[] | null;
};
export type ConfigureSurveyRequest = {
  surveyDesignId?: string | null;
  internalName?: string | null;
  displayName?: string | null;
  vendorName?: string | null;
  blocks?: ConfigureBlockRequest[] | null;
};
export type GenerateTestResponsesRequest = {
  responseCount?: number;
  qualityLevel?: string | null;
  customPrompt?: string | null;
  referralCode?: string | null;
};
export type ZeroSurveyResponse = {
  answers?: string[] | null;
};
export type SjsPlainData = {
  name?: string | null;
  title?: string | null;
  value?: any | null;
  displayValue?: any | null;
  otherText?: string | null;
  isNode?: boolean;
};
export type SjsVariable = {
  name?: string | null;
  value?: any | null;
};
export type SjsSurveyResponse = {
  eventId?: string | null;
  highlighterId?: string | null;
  surveyId?: string | null;
  surveyInstanceId?: string | null;
  timeSpentSeconds?: number;
  plainData?: SjsPlainData[] | null;
  variables?: SjsVariable[] | null;
};
export type VendorSurveyResponse = {
  vendorName?: string | null;
  vendorSurveyId?: string | null;
  vendorResponseId?: string | null;
  responseZero?: ZeroSurveyResponse;
  responseSjs?: SjsSurveyResponse;
};
export type SurveyResponse = {
  id?: string | null;
  externalId?: string | null;
  highlighterId?: string;
  surveyInstanceId?: string | null;
  surveyInstanceStatus?: string | null;
  surveyId?: string | null;
  resultSchemaId?: string | null;
  responseTags?: string[] | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  duration?: string | null;
  reviewStatus?: string | null;
};
export type BannerGroup = {
  label?: string | null;
  id?: string;
  ordinal?: number;
};
export type BannerPoint = {
  bannerPointId?: string | null;
  label?: string | null;
  combinedLabel?: string | null;
  bannerGroupId?: string | null;
  responseCount?: number;
  bannerDefinitionId?: string;
  surveyGroupId?: string;
  segmentId?: string;
};
export type EntryDataValue = {
  bannerPointId?: string | null;
  proportion?: number;
  count?: number;
  quantitativeNumericValues?: number[] | null;
  significance?: string[] | null;
  secondarySignificance?: string[] | null;
  withinQuestionSignificance?: string[] | null;
};
export type CrossTabEntry = {
  entryDataValues?: EntryDataValue[] | null;
  label?: string | null;
  numericalValue?: number;
  skipInCrossTabTable?: boolean;
};
export type CrossTabAggregation = {
  label?: string | null;
  slug?: string | null;
  value?: number;
  isProportion?: boolean;
  showInCrossTab?: boolean;
  significance?: string[] | null;
  secondarySignificance?: string[] | null;
};
export type CrossTabMetadata = {
  bannerPointId?: string | null;
  responseCount?: number;
  sigma?: number;
  aggregations?: CrossTabAggregation[] | null;
};
export type CrossTab = {
  entries?: CrossTabEntry[] | null;
  lineItemId?: string;
  label?: string | null;
  kind?: string | null;
  metadata?: CrossTabMetadata[] | null;
  isPreferenceQuestion?: boolean;
  ordinal?: number;
};
export type CrossTabsDto = {
  bannerGroups?: BannerGroup[] | null;
  bannerPoints?: BannerPoint[] | null;
  crossTabs?: CrossTab[] | null;
  significanceLevel?: number;
  secondarySignificanceLevel?: number | null;
};
export type SurveyGroup = {
  surveyConfigIds?: string[] | null;
  id?: string;
  label?: string | null;
  ordinal?: number;
  isCore?: boolean;
  productIds?: number[] | null;
  sourceProjectId?: number | null;
  color?: string | null;
};
export type CrossTabsDownloadRequest = {
  filePrefix?: string | null;
  resultContextId?: string;
  surveyGroups?: SurveyGroup[] | null;
  significanceLevel?: number | null;
  secondarySignificanceLevel?: number | null;
  segmentIds?: string[] | null;
  restrictToParticipantsOfTheseSurveyGroups?: SurveyGroup[] | null;
  fullCompletesOnly?: boolean;
  positionFilter?: number | null;
  projectId?: number | null;
  allProjectSurveyConfigIds?: string[] | null;
  requestedLineItemScope?: LineItemScope;
  lineItemIds?: string[] | null;
};
export type CrossTabsDownloadRequestRead = {
  filePrefix?: string | null;
  surveyConfigIds?: string[] | null;
  resultContextId?: string;
  surveyGroups?: SurveyGroup[] | null;
  significanceLevel?: number | null;
  secondarySignificanceLevel?: number | null;
  segmentIds?: string[] | null;
  restrictToParticipantsOfTheseSurveyGroups?: SurveyGroup[] | null;
  fullCompletesOnly?: boolean;
  positionFilter?: number | null;
  projectId?: number | null;
  allProjectSurveyConfigIds?: string[] | null;
  requestedLineItemScope?: LineItemScope;
  lineItemIds?: string[] | null;
};
export type ScorecardEntryMetadata = {
  bannerPointId?: string | null;
  aggregations?: CrossTabAggregation[] | null;
};
export type ScorecardEntryData = {
  lineItemId?: string;
  label?: string | null;
  ordinal?: number;
  aggregationType?: string | null;
  aggregationGroup?: string | null;
  metadata?: ScorecardEntryMetadata[] | null;
};
export type ScorecardDataDto = {
  bannerGroups?: BannerGroup[] | null;
  bannerPoints?: BannerPoint[] | null;
  significanceLevel?: number | null;
  secondarySignificanceLevel?: number | null;
  entries?: ScorecardEntryData[] | null;
  effectiveLineItemScope?: LineItemScope;
};
export type ScorecardDataRequest = {
  resultContextId?: string;
  surveyGroups?: SurveyGroup[] | null;
  segmentIds?: string[] | null;
  significanceLevel?: number | null;
  secondarySignificanceLevel?: number | null;
  fullCompletesOnly?: boolean;
  positionFilter?: number | null;
  projectId?: number | null;
  allProjectSurveyConfigIds?: string[] | null;
  restrictToParticipantsOfTheseSurveyGroups?: SurveyGroup[] | null;
  requestedLineItemScope?: LineItemScope;
};
export type PenaltyStatus = {
  slug?: string | null;
  display?: string | null;
  minInclusive?: number;
  maxExclusive?: number | null;
};
export type Group = {
  status?: string | null;
  label?: string | null;
  proportion?: number;
  meanOverall?: number | null;
  penalty?: number | null;
  weightedPenalty?: number | null;
  sampleSize?: number;
};
export type AttributeResult = {
  label?: string | null;
  low?: Group;
  jar?: Group;
  high?: Group;
};
export type PenaltyAnalysis = {
  label?: string | null;
  results?: AttributeResult[] | null;
  significanceLevel?: number;
};
export type PenaltyAnalysisDto = {
  statuses?: PenaltyStatus[] | null;
  analyses?: PenaltyAnalysis[] | null;
};
export type PenaltyAnalysisRequest = {
  resultContextId?: string | null;
  surveyGroups?: SurveyGroup[] | null;
  significanceLevel?: number | null;
  segmentIds?: string[] | null;
  fullCompletesOnly?: boolean;
  positionFilter?: number | null;
  projectId?: number | null;
  allProjectSurveyConfigIds?: string[] | null;
  requestedLineItemScope?: LineItemScope;
};
export type AlienationGroup = {
  n?: number;
  proportion?: number;
};
export type AlienationAnalysisResponse = {
  n?: number;
  alienated?: AlienationGroup;
  error?: AlienationGroup;
  likedEverything?: AlienationGroup;
  dislikedEverything?: AlienationGroup;
  verdict?: string | null;
  aggregationGroup?: string | null;
};
export type AlienationAnalysisRequest = {
  resultContextId?: string;
  control?: SurveyGroup;
  test?: SurveyGroup;
  fullCompletesOnly?: boolean;
  positionFilter?: number | null;
  projectId?: number | null;
  allProjectSurveyConfigIds?: string[] | null;
  requestedLineItemScope?: LineItemScope;
  segmentIds?: string[] | null;
};
export type AlienationAnalysisRequestRead = {
  resultContextId?: string;
  control?: SurveyGroup;
  test?: SurveyGroup;
  fullCompletesOnly?: boolean;
  positionFilter?: number | null;
  projectId?: number | null;
  allProjectSurveyConfigIds?: string[] | null;
  requestedLineItemScope?: LineItemScope;
  surveyGroups?: SurveyGroup[] | null;
  segmentIds?: string[] | null;
};
export type IssueSeverity = 'Critical' | 'Warning' | 'Suggestion';
export type ReviewIssue = {
  severity?: IssueSeverity;
  title?: string | null;
  description?: string | null;
  suggestedFix?: string | null;
};
export type SurveyReviewResult = {
  surveyConfigId?: string;
  surveyName?: string | null;
  issues?: ReviewIssue[] | null;
  reviewedAt?: string;
};
export type SurveyReviewResultRead = {
  surveyConfigId?: string;
  surveyName?: string | null;
  issues?: ReviewIssue[] | null;
  reviewedAt?: string;
  totalIssues?: number;
  criticalCount?: number;
  warningCount?: number;
  suggestionCount?: number;
};
export type SurveyReviewAllResult = {
  results?: SurveyReviewResult[] | null;
  reviewedAt?: string;
};
export type SurveyReviewAllResultRead = {
  results?: SurveyReviewResultRead[] | null;
  reviewedAt?: string;
  totalIssues?: number;
  criticalCount?: number;
  warningCount?: number;
};
export type SurveyReviewAllRequest = {
  surveyConfigIds?: string[] | null;
};
export type VariableLogic = {
  id?: string;
  surveyConfigId?: string;
  expressionTree?: SurveyExpression;
  key?: string | null;
  stringValue?: string | null;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
};
export type VariableLogicValidationFailure = {
  variableLogicId?: string;
  messages?: string[] | null;
};
export type VariableLogicValidationResults = {
  validationFailures?: VariableLogicValidationFailure[] | null;
};
export const {
  useGetAggregationtypesQuery,
  useGetAiGenerationJobByJobIdStatusQuery,
  useGetBackgroundjoblogsQuery,
  useGetBlocksQuery,
  usePostBlocksMutation,
  usePostBlocksBulkGetMutation,
  usePutBlocksByBlockIdMutation,
  useDeleteBlocksByBlockIdMutation,
  useGetBlocksQuestionDesignByQuestionDesignIdQuery,
  useGetBlockTypeOptionsQuery,
  usePostBlueprintsMutation,
  usePostBlueprintsBulkCreateMutation,
  usePostLineItemsByLineItemIdCustomTopicsMutation,
  useGetSurveyconfigsBySurveyConfigIdDisqualificationlogicsQuery,
  usePutSurveyconfigsBySurveyConfigIdDisqualificationlogicsAndIdMutation,
  useDeleteSurveyconfigsBySurveyConfigIdDisqualificationlogicsAndIdMutation,
  useGetSurveyconfigsBySurveyConfigIdDisqualificationlogicsValidationQuery,
  useGetExternalSurveysQuery,
  usePostHighlighterProfileSurveysMutation,
  usePatchHighlighterProfileSurveysMutation,
  useGetHighlighterProfileSurveysQuery,
  usePostHighlighterProfileSurveysFinalizeQuestionsMutation,
  useGetHighlighterProfileSurveysByIdQuery,
  usePostLineItemsMutation,
  usePutLineItemsMutation,
  useDeleteLineItemsByLineItemIdMutation,
  usePostLineItemsByLineItemIdSetordinalMutation,
  usePostLineItemsBatchMutation,
  useGetResultContextsByResultContextIdLineitemsQuery,
  usePostResultContextsByResultContextIdLineitemsMutation,
  useGetResultContextsByResultContextIdQuestioninventoryQuery,
  useGetResultContextsByResultContextIdLineitemsHasanyQuery,
  useGetMaterializedSurveysByMaterializedSurveyIdQuery,
  usePutMaterializedSurveysByMaterializedSurveyIdMutation,
  useGetMaterializedSurveysByMaterializedSurveyIdQuestionsQuery,
  useGetMaterializedSurveysByMaterializedSurveyIdJsonQuery,
  useGetProjectsByProjectIdMaxPositionsQuery,
  useGetPhotoqcreviewQuery,
  usePostQualitycontrolGetreportMutation,
  useGetQualitycontrolResponsedetailsBySurveyResponseIdQuery,
  usePostQualitycontrolSubmitReviewMutation,
  usePostQualitycontrolSetAnswerExcludedMutation,
  useGetQuestionChoicesByChoiceIdQuery,
  usePatchQuestionChoicesByChoiceIdMutation,
  usePostQuestionDesignsByQuestionDesignIdChoicesAssignMutation,
  useGetQuestionDesignsByQuestionDesignIdChoicesQuery,
  useGetQuestionDesignsQuery,
  usePostQuestionDesignsMutation,
  usePutQuestionDesignsByQuestionDesignIdMutation,
  useGetQuestionsQuery,
  usePostQuestionsByQuestionIdConvertMutation,
  useGetQuestionsByQuestionIdQuery,
  usePatchQuestionsByQuestionIdMutation,
  useGetResultContextsQuery,
  usePostResultContextsMutation,
  usePostResultContextsByResultContextIdDeletesummariesMutation,
  useGetResultContextsByResultContextIdSummarycountQuery,
  usePostResultContextsByResultContextIdResetDashboardMutation,
  useGetResultContextsByResultContextIdScorecardentriesQuery,
  usePostScoreCardEntriesMutation,
  usePutScoreCardEntriesMutation,
  usePostScoreCardEntriesBatchMutation,
  usePatchScoreCardEntriesUpdateOrdinalsMutation,
  useDeleteScoreCardEntriesByScorecardEntryIdMutation,
  useGetSegmentsResultcontextsByResultContextIdEnabledSegmentsQuery,
  useDeleteSegmentsByIdMutation,
  usePostSegmentsResultcontextsByResultContextIdBackfillDefaultSegmentsMutation,
  useGetSurveyconfigsBySurveyConfigIdShowlogicsQuery,
  useGetSurveyconfigsBySurveyConfigIdShowlogicsAndIdQuery,
  usePutSurveyconfigsBySurveyConfigIdShowlogicsAndIdMutation,
  useDeleteSurveyconfigsBySurveyConfigIdShowlogicsAndIdMutation,
  useGetSurveyconfigsBySurveyConfigIdShowlogicsValidationQuery,
  useGetBlocksByBlockIdSlotsQuery,
  usePostBlocksByBlockIdSlotsAssignMutation,
  usePostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsCreateMatrixGroupMutation,
  usePostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdAddMatrixBlockMutation,
  useGetSurveyConfigBlockGroupsQuery,
  useDeleteSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdMutation,
  usePatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdNameMutation,
  usePatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdAreQuestionsRequiredMutation,
  usePatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdBehaviorsMutation,
  usePatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdBlockIdsMutation,
  usePostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdPreviewMutation,
  usePostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdCloneMutation,
  useGetSurveyConfigsBySurveyConfigIdBlocksQuery,
  usePostSurveyConfigsBySurveyConfigIdBlocksAndSurveyConfigBlockIdCloneMutation,
  useGetSurveyConfigsBySurveyConfigIdQuestionsQuery,
  useGetSurveyConfigsBySurveyConfigIdResponseTagCountsQuery,
  useGetSurveyConfigsQuery,
  usePostSurveyConfigsConfigureMutation,
  usePostSurveyConfigsBySurveyConfigIdStartreportingMutation,
  useGetSurveyConfigsBySurveyConfigIdDefinitionQuery,
  usePostSurveyConfigsBySurveyConfigIdExportDocxMutation,
  usePostSurveyConfigsBySurveyConfigIdResetresultschemaMutation,
  usePostSurveyConfigsBySurveyConfigIdGenerateTestResponsesMutation,
  usePostSurveyingestorsByVendorNameResponsesMutation,
  useGetSurveyresponsesQuery,
  useDeleteSurveyresponsesMutation,
  useGetSurveyresponsesByIdSurveyConfigQuery,
  usePostSurveyresponsesByResultSchemaIdUploadTagsMutation,
  usePostSurveyresultsGetcrosstabdataMutation,
  usePostSurveyresultsGetscorecarddataMutation,
  usePostSurveyresultsGetpenaltyanalysisMutation,
  usePostSurveyresultsGetalienationanalysisMutation,
  usePostSurveyReviewReviewAllMutation,
  usePostTextprocessingByResultSchemaIdStartMutation,
  useGetSurveyConfigsBySurveyConfigIdVariableLogicsQuery,
  usePutSurveyConfigsBySurveyConfigIdVariableLogicsAndIdMutation,
  useDeleteSurveyConfigsBySurveyConfigIdVariableLogicsAndIdMutation,
  useGetSurveyConfigsBySurveyConfigIdVariableLogicsValidationQuery,
} = injectedRtkApi;
